/* THIS IS A GENERATED FILE, DO NOT EDIT */
import * as GraphqlTypes from "./mainTypes";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export const ArenaFieldsFragmentDoc = gql`
    fragment ArenaFields on ArenaObjectType {
  id
  name
  domain
  emailDomain
  isIdsTermsOfServiceSigned
  packagingEdition {
    id
    name
    label
  }
  capitalCallEmailDistributionListId
  capitalActivityEmailDistributionListId
  distributionEmailDistributionListId
  reportEmailDistributionListId
  netIncomeEmailDistributionListId
  managementFeeEmailDistributionListId
  capitalCallDocumentCategoryId
  capitalActivityDocumentCategoryId
  distributionDocumentCategoryId
  statementDocumentCategoryId
  netIncomeDocumentCategoryId
  netNoticeDocumentCategoryId
  lookerVerificationRecordValue
  lookerAcmeRecordValue
  lookerInstanceId
  lookerApiKeyIdValue
  lookerApiKeySecretValue
}
    `;
export const EditArenaFieldsFragmentDoc = gql`
    fragment EditArenaFields on EditArenaResponse {
  __typename
  ... on MutationErrorResponse {
    errorCode
    message
  }
  ... on EditArenaObject {
    arena {
      ...ArenaFields
      features {
        hasTransferAccounting
        hasPortalInvites
        hasYardiImImport
        hasParallelFunds
        hasSubscriptions
        hasUnifiedLpSubscription
        hasEditableLpPaymentPreferences
        hasAdvancedPermissions
        hasYardiVoyagerIntegration
        hasFundAdmin
        hasCustomerEmailServer
        hasEmailServiceProviderMailgun
        hasOutlookIntegration
        hasAnalytics
        hasInsightEtl
        insightsExportOnly
        hasNetIncomeSettings
        hasNetAssetValueSettings
        hasOpenEndFundSettings
        hasAccountValuesSettings
        supportsComprehensiveAuditLog
        supportsCustomDataFields
        supportsDynamicSubscriptionQuestions
        supportsIlpaNotices
        supportsMultipleNda
        supportsMultipleStationery
        supportsProspectTableCustomization
        supportsTimeWeightedReturn
        supportsWatermarking
        hasAutomatedPayments
        hasOperatingCompanies
        hasUnifiedPortalPreview
        hasSso
        hasNewOwnershipTypes
        hasAutoSubscribeLeads
        supportsEntityLevelContacts
        requireLpAccreditationAndPreferences
        showFundAdminDeliverablesModule
        showFaAccountingTab
        hasGpxIntegration
        hasDynamicSubscriptions
        hasDynamicSubscriptionsCustomSections
        mappingTabAdminSettings
        hasGpxIntegrationExport
        hasProspectOptimization
        hasHubspotIntegration
        hasGlDataForSoi
        hasLpcmAutomaticUpdateAndRemoval
        hasContactLastUpdateOptimization
        hasExternalAuthentication
        hasEditAndDeleteActivity
        hasZapierIntegration
        hasBankAccountShowSwiftUi
        hasSwiftPayments
        hasBulkCountersign
        showOwnershipTabWithNewLogic
        enablePublishToDataFabric
        useDocusignOauthFor2fa
        hasSftpDocumentPosting
        hasCreditAppIntegration
        hasCountersignerGroups
      }
    }
    provisioningJob {
      id
    }
  }
}
    ${ArenaFieldsFragmentDoc}`;
export const AsyncJobFieldsFragmentDoc = gql`
    fragment AsyncJobFields on AsyncJobObjectType {
  id
  jobType
  status
  startTime
  endTime
  data
}
    `;
export const SubscriptionCcLogDumpFieldsFragmentDoc = gql`
    fragment SubscriptionCCLogDumpFields on SubscriptionObjectType {
  id
  status
  ccLogDump {
    accountContactsInfo
    accountInfo
    additionalContactsInfo
    counterparties
    docusignData
    paymentInfo
  }
}
    `;
export const TransactionDescriptionFieldsFragmentDoc = gql`
    fragment TransactionDescriptionFields on TransactionDescriptionResponse {
  __typename
  ... on TransactionDescriptionNotFoundResponse {
    id
    errorCode
    message
  }
  ... on TransactionDescriptionObjectType {
    id
    description
  }
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on UserObjectType {
  id
  fullName
  firstName
  lastName
  emailAddress
  lastLogin
  newsletterSubscribed
  newsletterSubscriptionType
  isActive
  hasLinkedGlobalUser
  twoFaEnabled
  twoFaPhoneNumber
  currentTwoFaMethods
}
    `;
export const RoleFieldsFragmentDoc = gql`
    fragment RoleFields on RoleObjectType {
  id
  name
}
    `;
export const GroupFieldsFragmentDoc = gql`
    fragment GroupFields on GroupObjectType {
  id
  title
  roles {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;
export const UserAccessFieldsFragmentDoc = gql`
    fragment UserAccessFields on UserObjectType {
  id
  canAccessAdminArena
  isComplianceUser
  isKycUser
  isTreasuryUser
  isCanopyUser
  roles {
    edges {
      node {
        name
      }
    }
  }
}
    `;
export const EntityFieldsFragmentDoc = gql`
    fragment EntityFields on AccountObjectType {
  id
  name
  status
  isPartial
}
    `;
export const EditArenaDocument = gql`
    mutation EditArena($arenaId: ID!, $input: EditArenaInput!) {
  arenaOps {
    edit(objectId: $arenaId, objectInput: $input) {
      result {
        ...EditArenaFields
      }
    }
  }
}
    ${EditArenaFieldsFragmentDoc}`;
export type EditArenaMutationFn = Apollo.MutationFunction<GraphqlTypes.EditArenaMutation, GraphqlTypes.EditArenaMutationVariables>;

/**
 * __useEditArenaMutation__
 *
 * To run a mutation, you first call `useEditArenaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditArenaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editArenaMutation, { data, loading, error }] = useEditArenaMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditArenaMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EditArenaMutation, GraphqlTypes.EditArenaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EditArenaMutation, GraphqlTypes.EditArenaMutationVariables>(EditArenaDocument, options);
      }
export type EditArenaMutationHookResult = ReturnType<typeof useEditArenaMutation>;
export type EditArenaMutationResult = Apollo.MutationResult<GraphqlTypes.EditArenaMutation>;
export type EditArenaMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EditArenaMutation, GraphqlTypes.EditArenaMutationVariables>;
export const DeactivateArenaDocument = gql`
    mutation DeactivateArena($arenaId: ID!) {
  arenaOps {
    deactivate(objectId: $arenaId) {
      arena {
        ...ArenaFields
      }
    }
  }
}
    ${ArenaFieldsFragmentDoc}`;
export type DeactivateArenaMutationFn = Apollo.MutationFunction<GraphqlTypes.DeactivateArenaMutation, GraphqlTypes.DeactivateArenaMutationVariables>;

/**
 * __useDeactivateArenaMutation__
 *
 * To run a mutation, you first call `useDeactivateArenaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateArenaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateArenaMutation, { data, loading, error }] = useDeactivateArenaMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useDeactivateArenaMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeactivateArenaMutation, GraphqlTypes.DeactivateArenaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeactivateArenaMutation, GraphqlTypes.DeactivateArenaMutationVariables>(DeactivateArenaDocument, options);
      }
export type DeactivateArenaMutationHookResult = ReturnType<typeof useDeactivateArenaMutation>;
export type DeactivateArenaMutationResult = Apollo.MutationResult<GraphqlTypes.DeactivateArenaMutation>;
export type DeactivateArenaMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeactivateArenaMutation, GraphqlTypes.DeactivateArenaMutationVariables>;
export const ReactivateArenaDocument = gql`
    mutation ReactivateArena($arenaId: ID!) {
  arenaOps {
    reactivate(objectId: $arenaId) {
      arena {
        ...ArenaFields
      }
    }
  }
}
    ${ArenaFieldsFragmentDoc}`;
export type ReactivateArenaMutationFn = Apollo.MutationFunction<GraphqlTypes.ReactivateArenaMutation, GraphqlTypes.ReactivateArenaMutationVariables>;

/**
 * __useReactivateArenaMutation__
 *
 * To run a mutation, you first call `useReactivateArenaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateArenaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateArenaMutation, { data, loading, error }] = useReactivateArenaMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useReactivateArenaMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ReactivateArenaMutation, GraphqlTypes.ReactivateArenaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ReactivateArenaMutation, GraphqlTypes.ReactivateArenaMutationVariables>(ReactivateArenaDocument, options);
      }
export type ReactivateArenaMutationHookResult = ReturnType<typeof useReactivateArenaMutation>;
export type ReactivateArenaMutationResult = Apollo.MutationResult<GraphqlTypes.ReactivateArenaMutation>;
export type ReactivateArenaMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ReactivateArenaMutation, GraphqlTypes.ReactivateArenaMutationVariables>;
export const GetAsyncJobDocument = gql`
    query GetAsyncJob($jobId: ID!, $arenaId: ID) {
  asyncJob(id: $jobId, managerArenaId: $arenaId) {
    ...AsyncJobFields
  }
}
    ${AsyncJobFieldsFragmentDoc}`;

/**
 * __useGetAsyncJobQuery__
 *
 * To run a query within a React component, call `useGetAsyncJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAsyncJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAsyncJobQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetAsyncJobQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAsyncJobQuery, GraphqlTypes.GetAsyncJobQueryVariables> & ({ variables: GraphqlTypes.GetAsyncJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAsyncJobQuery, GraphqlTypes.GetAsyncJobQueryVariables>(GetAsyncJobDocument, options);
      }
export function useGetAsyncJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAsyncJobQuery, GraphqlTypes.GetAsyncJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAsyncJobQuery, GraphqlTypes.GetAsyncJobQueryVariables>(GetAsyncJobDocument, options);
        }
// @ts-ignore
export function useGetAsyncJobSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAsyncJobQuery, GraphqlTypes.GetAsyncJobQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAsyncJobQuery, GraphqlTypes.GetAsyncJobQueryVariables>;
export function useGetAsyncJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAsyncJobQuery, GraphqlTypes.GetAsyncJobQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAsyncJobQuery | undefined, GraphqlTypes.GetAsyncJobQueryVariables>;
export function useGetAsyncJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAsyncJobQuery, GraphqlTypes.GetAsyncJobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAsyncJobQuery, GraphqlTypes.GetAsyncJobQueryVariables>(GetAsyncJobDocument, options);
        }
export type GetAsyncJobQueryHookResult = ReturnType<typeof useGetAsyncJobQuery>;
export type GetAsyncJobLazyQueryHookResult = ReturnType<typeof useGetAsyncJobLazyQuery>;
export type GetAsyncJobSuspenseQueryHookResult = ReturnType<typeof useGetAsyncJobSuspenseQuery>;
export type GetAsyncJobQueryResult = Apollo.QueryResult<GraphqlTypes.GetAsyncJobQuery, GraphqlTypes.GetAsyncJobQueryVariables>;
export const GetAsyncJobProgressDocument = gql`
    query GetAsyncJobProgress($jobId: ID!, $arenaId: ID) {
  asyncJob(id: $jobId, managerArenaId: $arenaId) {
    id
    jobType
    status
    startTime
    endTime
    progress {
      processedCount
      totalCount
    }
    redisData
  }
}
    `;

/**
 * __useGetAsyncJobProgressQuery__
 *
 * To run a query within a React component, call `useGetAsyncJobProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAsyncJobProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAsyncJobProgressQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetAsyncJobProgressQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAsyncJobProgressQuery, GraphqlTypes.GetAsyncJobProgressQueryVariables> & ({ variables: GraphqlTypes.GetAsyncJobProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAsyncJobProgressQuery, GraphqlTypes.GetAsyncJobProgressQueryVariables>(GetAsyncJobProgressDocument, options);
      }
export function useGetAsyncJobProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAsyncJobProgressQuery, GraphqlTypes.GetAsyncJobProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAsyncJobProgressQuery, GraphqlTypes.GetAsyncJobProgressQueryVariables>(GetAsyncJobProgressDocument, options);
        }
// @ts-ignore
export function useGetAsyncJobProgressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAsyncJobProgressQuery, GraphqlTypes.GetAsyncJobProgressQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAsyncJobProgressQuery, GraphqlTypes.GetAsyncJobProgressQueryVariables>;
export function useGetAsyncJobProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAsyncJobProgressQuery, GraphqlTypes.GetAsyncJobProgressQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAsyncJobProgressQuery | undefined, GraphqlTypes.GetAsyncJobProgressQueryVariables>;
export function useGetAsyncJobProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAsyncJobProgressQuery, GraphqlTypes.GetAsyncJobProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAsyncJobProgressQuery, GraphqlTypes.GetAsyncJobProgressQueryVariables>(GetAsyncJobProgressDocument, options);
        }
export type GetAsyncJobProgressQueryHookResult = ReturnType<typeof useGetAsyncJobProgressQuery>;
export type GetAsyncJobProgressLazyQueryHookResult = ReturnType<typeof useGetAsyncJobProgressLazyQuery>;
export type GetAsyncJobProgressSuspenseQueryHookResult = ReturnType<typeof useGetAsyncJobProgressSuspenseQuery>;
export type GetAsyncJobProgressQueryResult = Apollo.QueryResult<GraphqlTypes.GetAsyncJobProgressQuery, GraphqlTypes.GetAsyncJobProgressQueryVariables>;
export const GetTransactionTypesDocument = gql`
    query GetTransactionTypes {
  distributionTypes {
    id
    name
    sortOrder
    isReturnOfCapital
    isWithholding
    excludeFromYield
  }
  contributionTypes: transactionTypes(signEffect: positive) {
    id
    name
    sortOrder
    isPositive
    isNegative
    isSubType
    affectsOwnership
    affectsCommitment
    excludeFromMetrics
  }
  redemptionTypes: transactionTypes(signEffect: negative) {
    id
    name
    sortOrder
    isPositive
    isNegative
    isSubType
    affectsOwnership
    affectsCommitment
    excludeFromMetrics
  }
  netIncomeTypes {
    id
    name
    sortOrder
  }
  navTypes {
    id
    name
    sortOrder
  }
}
    `;

/**
 * __useGetTransactionTypesQuery__
 *
 * To run a query within a React component, call `useGetTransactionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTransactionTypesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetTransactionTypesQuery, GraphqlTypes.GetTransactionTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTransactionTypesQuery, GraphqlTypes.GetTransactionTypesQueryVariables>(GetTransactionTypesDocument, options);
      }
export function useGetTransactionTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTransactionTypesQuery, GraphqlTypes.GetTransactionTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTransactionTypesQuery, GraphqlTypes.GetTransactionTypesQueryVariables>(GetTransactionTypesDocument, options);
        }
// @ts-ignore
export function useGetTransactionTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionTypesQuery, GraphqlTypes.GetTransactionTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransactionTypesQuery, GraphqlTypes.GetTransactionTypesQueryVariables>;
export function useGetTransactionTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionTypesQuery, GraphqlTypes.GetTransactionTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransactionTypesQuery | undefined, GraphqlTypes.GetTransactionTypesQueryVariables>;
export function useGetTransactionTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionTypesQuery, GraphqlTypes.GetTransactionTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTransactionTypesQuery, GraphqlTypes.GetTransactionTypesQueryVariables>(GetTransactionTypesDocument, options);
        }
export type GetTransactionTypesQueryHookResult = ReturnType<typeof useGetTransactionTypesQuery>;
export type GetTransactionTypesLazyQueryHookResult = ReturnType<typeof useGetTransactionTypesLazyQuery>;
export type GetTransactionTypesSuspenseQueryHookResult = ReturnType<typeof useGetTransactionTypesSuspenseQuery>;
export type GetTransactionTypesQueryResult = Apollo.QueryResult<GraphqlTypes.GetTransactionTypesQuery, GraphqlTypes.GetTransactionTypesQueryVariables>;
export const CreateUserLegacyDocument = gql`
    mutation CreateUserLegacy($arenaId: ID, $firstName: String!, $lastName: String!, $emailAddress: String!, $newsletterSubscribed: Boolean, $newsletterSubscriptionType: NewsletterSubscriptionTypes, $sendActivationEmail: Boolean, $roles: [String!], $groups: [String!], $isGlobal: Boolean) {
  userOps {
    createUser(
      arenaId: $arenaId
      firstName: $firstName
      lastName: $lastName
      emailAddress: $emailAddress
      newsletterSubscribed: $newsletterSubscribed
      newsletterSubscriptionType: $newsletterSubscriptionType
      sendActivationEmail: $sendActivationEmail
      roles: $roles
      groups: $groups
      isGlobal: $isGlobal
    ) {
      user {
        ...UserFields
        roles {
          edges {
            node {
              ...RoleFields
            }
          }
        }
        groups {
          edges {
            node {
              ...GroupFields
            }
          }
        }
        arena {
          id
          name
        }
        contact {
          fullName
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${RoleFieldsFragmentDoc}
${GroupFieldsFragmentDoc}`;
export type CreateUserLegacyMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateUserLegacyMutation, GraphqlTypes.CreateUserLegacyMutationVariables>;

/**
 * __useCreateUserLegacyMutation__
 *
 * To run a mutation, you first call `useCreateUserLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserLegacyMutation, { data, loading, error }] = useCreateUserLegacyMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      emailAddress: // value for 'emailAddress'
 *      newsletterSubscribed: // value for 'newsletterSubscribed'
 *      newsletterSubscriptionType: // value for 'newsletterSubscriptionType'
 *      sendActivationEmail: // value for 'sendActivationEmail'
 *      roles: // value for 'roles'
 *      groups: // value for 'groups'
 *      isGlobal: // value for 'isGlobal'
 *   },
 * });
 */
export function useCreateUserLegacyMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateUserLegacyMutation, GraphqlTypes.CreateUserLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateUserLegacyMutation, GraphqlTypes.CreateUserLegacyMutationVariables>(CreateUserLegacyDocument, options);
      }
export type CreateUserLegacyMutationHookResult = ReturnType<typeof useCreateUserLegacyMutation>;
export type CreateUserLegacyMutationResult = Apollo.MutationResult<GraphqlTypes.CreateUserLegacyMutation>;
export type CreateUserLegacyMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateUserLegacyMutation, GraphqlTypes.CreateUserLegacyMutationVariables>;
export const EditUserLegacyDocument = gql`
    mutation EditUserLegacy($userId: ID!, $arenaId: ID, $input: EditUserInput!) {
  userOps {
    editUser(objectId: $userId, arenaId: $arenaId, objectInput: $input) {
      user {
        ...UserFields
        roles {
          edges {
            node {
              ...RoleFields
            }
          }
        }
        groups {
          edges {
            node {
              ...GroupFields
            }
          }
        }
        arena {
          id
          name
        }
        contact {
          fullName
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${RoleFieldsFragmentDoc}
${GroupFieldsFragmentDoc}`;
export type EditUserLegacyMutationFn = Apollo.MutationFunction<GraphqlTypes.EditUserLegacyMutation, GraphqlTypes.EditUserLegacyMutationVariables>;

/**
 * __useEditUserLegacyMutation__
 *
 * To run a mutation, you first call `useEditUserLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserLegacyMutation, { data, loading, error }] = useEditUserLegacyMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      arenaId: // value for 'arenaId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditUserLegacyMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EditUserLegacyMutation, GraphqlTypes.EditUserLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EditUserLegacyMutation, GraphqlTypes.EditUserLegacyMutationVariables>(EditUserLegacyDocument, options);
      }
export type EditUserLegacyMutationHookResult = ReturnType<typeof useEditUserLegacyMutation>;
export type EditUserLegacyMutationResult = Apollo.MutationResult<GraphqlTypes.EditUserLegacyMutation>;
export type EditUserLegacyMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EditUserLegacyMutation, GraphqlTypes.EditUserLegacyMutationVariables>;
export const GenerateTotpDocument = gql`
    mutation GenerateTotp($userId: ID!) {
  userOps {
    generateTotp(objectId: $userId) {
      totpKey
      qrCode
    }
  }
}
    `;
export type GenerateTotpMutationFn = Apollo.MutationFunction<GraphqlTypes.GenerateTotpMutation, GraphqlTypes.GenerateTotpMutationVariables>;

/**
 * __useGenerateTotpMutation__
 *
 * To run a mutation, you first call `useGenerateTotpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTotpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTotpMutation, { data, loading, error }] = useGenerateTotpMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGenerateTotpMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GenerateTotpMutation, GraphqlTypes.GenerateTotpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GenerateTotpMutation, GraphqlTypes.GenerateTotpMutationVariables>(GenerateTotpDocument, options);
      }
export type GenerateTotpMutationHookResult = ReturnType<typeof useGenerateTotpMutation>;
export type GenerateTotpMutationResult = Apollo.MutationResult<GraphqlTypes.GenerateTotpMutation>;
export type GenerateTotpMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GenerateTotpMutation, GraphqlTypes.GenerateTotpMutationVariables>;
export const DownloadTwrDataDocument = gql`
    mutation DownloadTwrData($globalUserId: ID!) {
  userOps {
    generateTwrData(globalUserId: $globalUserId) {
      job {
        id
      }
    }
  }
}
    `;
export type DownloadTwrDataMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadTwrDataMutation, GraphqlTypes.DownloadTwrDataMutationVariables>;

/**
 * __useDownloadTwrDataMutation__
 *
 * To run a mutation, you first call `useDownloadTwrDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadTwrDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadTwrDataMutation, { data, loading, error }] = useDownloadTwrDataMutation({
 *   variables: {
 *      globalUserId: // value for 'globalUserId'
 *   },
 * });
 */
export function useDownloadTwrDataMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadTwrDataMutation, GraphqlTypes.DownloadTwrDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadTwrDataMutation, GraphqlTypes.DownloadTwrDataMutationVariables>(DownloadTwrDataDocument, options);
      }
export type DownloadTwrDataMutationHookResult = ReturnType<typeof useDownloadTwrDataMutation>;
export type DownloadTwrDataMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadTwrDataMutation>;
export type DownloadTwrDataMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadTwrDataMutation, GraphqlTypes.DownloadTwrDataMutationVariables>;
export const DowngradeStaffOrHybridUserToEmail2FaDocument = gql`
    mutation DowngradeStaffOrHybridUserToEmail2FA($object_input: DowngradeStaffOrHybridUserToEmail2FAInput!) {
  userOps {
    downgradeStaffOrHybridUserToEmail2fa(objectInput: $object_input) {
      ... on DowngradeStaffOrHybridUserToEmail2FAObject {
        isSuccess
      }
      ... on MutationErrorResponse {
        errorCode
        message
      }
    }
  }
}
    `;
export type DowngradeStaffOrHybridUserToEmail2FaMutationFn = Apollo.MutationFunction<GraphqlTypes.DowngradeStaffOrHybridUserToEmail2FaMutation, GraphqlTypes.DowngradeStaffOrHybridUserToEmail2FaMutationVariables>;

/**
 * __useDowngradeStaffOrHybridUserToEmail2FaMutation__
 *
 * To run a mutation, you first call `useDowngradeStaffOrHybridUserToEmail2FaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDowngradeStaffOrHybridUserToEmail2FaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downgradeStaffOrHybridUserToEmail2FaMutation, { data, loading, error }] = useDowngradeStaffOrHybridUserToEmail2FaMutation({
 *   variables: {
 *      object_input: // value for 'object_input'
 *   },
 * });
 */
export function useDowngradeStaffOrHybridUserToEmail2FaMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DowngradeStaffOrHybridUserToEmail2FaMutation, GraphqlTypes.DowngradeStaffOrHybridUserToEmail2FaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DowngradeStaffOrHybridUserToEmail2FaMutation, GraphqlTypes.DowngradeStaffOrHybridUserToEmail2FaMutationVariables>(DowngradeStaffOrHybridUserToEmail2FaDocument, options);
      }
export type DowngradeStaffOrHybridUserToEmail2FaMutationHookResult = ReturnType<typeof useDowngradeStaffOrHybridUserToEmail2FaMutation>;
export type DowngradeStaffOrHybridUserToEmail2FaMutationResult = Apollo.MutationResult<GraphqlTypes.DowngradeStaffOrHybridUserToEmail2FaMutation>;
export type DowngradeStaffOrHybridUserToEmail2FaMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DowngradeStaffOrHybridUserToEmail2FaMutation, GraphqlTypes.DowngradeStaffOrHybridUserToEmail2FaMutationVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  currentUser {
    id
    firstName
    lastName
    fullName
    ...UserAccessFields
    roles {
      edges {
        node {
          name
        }
      }
    }
  }
}
    ${UserAccessFieldsFragmentDoc}`;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCurrentUserQuery, GraphqlTypes.GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCurrentUserQuery, GraphqlTypes.GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCurrentUserQuery, GraphqlTypes.GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCurrentUserQuery, GraphqlTypes.GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentUserQuery, GraphqlTypes.GetCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentUserQuery, GraphqlTypes.GetCurrentUserQueryVariables>;
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentUserQuery, GraphqlTypes.GetCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentUserQuery | undefined, GraphqlTypes.GetCurrentUserQueryVariables>;
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentUserQuery, GraphqlTypes.GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCurrentUserQuery, GraphqlTypes.GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GraphqlTypes.GetCurrentUserQuery, GraphqlTypes.GetCurrentUserQueryVariables>;
export const GeneratePresignedUrlsDocument = gql`
    mutation generatePresignedUrls($urlGeneratorInput: [PresignedUrlInput]!) {
  generatePresignedUrls(urlGeneratorInput: $urlGeneratorInput) {
    presignedUrlObjs {
      s3Url
      objectKey
      fileName
    }
  }
}
    `;
export type GeneratePresignedUrlsMutationFn = Apollo.MutationFunction<GraphqlTypes.GeneratePresignedUrlsMutation, GraphqlTypes.GeneratePresignedUrlsMutationVariables>;

/**
 * __useGeneratePresignedUrlsMutation__
 *
 * To run a mutation, you first call `useGeneratePresignedUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePresignedUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePresignedUrlsMutation, { data, loading, error }] = useGeneratePresignedUrlsMutation({
 *   variables: {
 *      urlGeneratorInput: // value for 'urlGeneratorInput'
 *   },
 * });
 */
export function useGeneratePresignedUrlsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GeneratePresignedUrlsMutation, GraphqlTypes.GeneratePresignedUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GeneratePresignedUrlsMutation, GraphqlTypes.GeneratePresignedUrlsMutationVariables>(GeneratePresignedUrlsDocument, options);
      }
export type GeneratePresignedUrlsMutationHookResult = ReturnType<typeof useGeneratePresignedUrlsMutation>;
export type GeneratePresignedUrlsMutationResult = Apollo.MutationResult<GraphqlTypes.GeneratePresignedUrlsMutation>;
export type GeneratePresignedUrlsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GeneratePresignedUrlsMutation, GraphqlTypes.GeneratePresignedUrlsMutationVariables>;
export const GetESignatureCcLogDumpDocument = gql`
    query GetESignatureCCLogDump($arenaId: ID!, $id: ID!) {
  eSignatureRequestTemplateCcLog(arenaId: $arenaId, id: $id) {
    id
    status
    eSignatureRequests
    eSignatureRequestRecipients
    eSignatureLpSigners
    eSignatureGpSigners
    eSignatureRequestData
  }
}
    `;

/**
 * __useGetESignatureCcLogDumpQuery__
 *
 * To run a query within a React component, call `useGetESignatureCcLogDumpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetESignatureCcLogDumpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetESignatureCcLogDumpQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetESignatureCcLogDumpQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetESignatureCcLogDumpQuery, GraphqlTypes.GetESignatureCcLogDumpQueryVariables> & ({ variables: GraphqlTypes.GetESignatureCcLogDumpQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetESignatureCcLogDumpQuery, GraphqlTypes.GetESignatureCcLogDumpQueryVariables>(GetESignatureCcLogDumpDocument, options);
      }
export function useGetESignatureCcLogDumpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetESignatureCcLogDumpQuery, GraphqlTypes.GetESignatureCcLogDumpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetESignatureCcLogDumpQuery, GraphqlTypes.GetESignatureCcLogDumpQueryVariables>(GetESignatureCcLogDumpDocument, options);
        }
// @ts-ignore
export function useGetESignatureCcLogDumpSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureCcLogDumpQuery, GraphqlTypes.GetESignatureCcLogDumpQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESignatureCcLogDumpQuery, GraphqlTypes.GetESignatureCcLogDumpQueryVariables>;
export function useGetESignatureCcLogDumpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureCcLogDumpQuery, GraphqlTypes.GetESignatureCcLogDumpQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetESignatureCcLogDumpQuery | undefined, GraphqlTypes.GetESignatureCcLogDumpQueryVariables>;
export function useGetESignatureCcLogDumpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetESignatureCcLogDumpQuery, GraphqlTypes.GetESignatureCcLogDumpQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetESignatureCcLogDumpQuery, GraphqlTypes.GetESignatureCcLogDumpQueryVariables>(GetESignatureCcLogDumpDocument, options);
        }
export type GetESignatureCcLogDumpQueryHookResult = ReturnType<typeof useGetESignatureCcLogDumpQuery>;
export type GetESignatureCcLogDumpLazyQueryHookResult = ReturnType<typeof useGetESignatureCcLogDumpLazyQuery>;
export type GetESignatureCcLogDumpSuspenseQueryHookResult = ReturnType<typeof useGetESignatureCcLogDumpSuspenseQuery>;
export type GetESignatureCcLogDumpQueryResult = Apollo.QueryResult<GraphqlTypes.GetESignatureCcLogDumpQuery, GraphqlTypes.GetESignatureCcLogDumpQueryVariables>;
export const GetInvestorDiligenceCcLogDocument = gql`
    query GetInvestorDiligenceCCLog($id: ID!, $arenaId: ID!) {
  investorDiligence(id: $id, arenaId: $arenaId) {
    id
    status
    investorDiligenceCcLogDump {
      investorDiligenceComments
      kycDetails
      kycDocuments
      peerReviewEndDate
      peerReviewerUserId
      peerReviewStartDate
      reviewEndDate
      reviewStartDate
      reviewerUserId
      status
      watchlistScreeningDetails
      watchlistScreeningLogs
    }
  }
}
    `;

/**
 * __useGetInvestorDiligenceCcLogQuery__
 *
 * To run a query within a React component, call `useGetInvestorDiligenceCcLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestorDiligenceCcLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestorDiligenceCcLogQuery({
 *   variables: {
 *      id: // value for 'id'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetInvestorDiligenceCcLogQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvestorDiligenceCcLogQuery, GraphqlTypes.GetInvestorDiligenceCcLogQueryVariables> & ({ variables: GraphqlTypes.GetInvestorDiligenceCcLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestorDiligenceCcLogQuery, GraphqlTypes.GetInvestorDiligenceCcLogQueryVariables>(GetInvestorDiligenceCcLogDocument, options);
      }
export function useGetInvestorDiligenceCcLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestorDiligenceCcLogQuery, GraphqlTypes.GetInvestorDiligenceCcLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestorDiligenceCcLogQuery, GraphqlTypes.GetInvestorDiligenceCcLogQueryVariables>(GetInvestorDiligenceCcLogDocument, options);
        }
// @ts-ignore
export function useGetInvestorDiligenceCcLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestorDiligenceCcLogQuery, GraphqlTypes.GetInvestorDiligenceCcLogQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestorDiligenceCcLogQuery, GraphqlTypes.GetInvestorDiligenceCcLogQueryVariables>;
export function useGetInvestorDiligenceCcLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestorDiligenceCcLogQuery, GraphqlTypes.GetInvestorDiligenceCcLogQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestorDiligenceCcLogQuery | undefined, GraphqlTypes.GetInvestorDiligenceCcLogQueryVariables>;
export function useGetInvestorDiligenceCcLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestorDiligenceCcLogQuery, GraphqlTypes.GetInvestorDiligenceCcLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestorDiligenceCcLogQuery, GraphqlTypes.GetInvestorDiligenceCcLogQueryVariables>(GetInvestorDiligenceCcLogDocument, options);
        }
export type GetInvestorDiligenceCcLogQueryHookResult = ReturnType<typeof useGetInvestorDiligenceCcLogQuery>;
export type GetInvestorDiligenceCcLogLazyQueryHookResult = ReturnType<typeof useGetInvestorDiligenceCcLogLazyQuery>;
export type GetInvestorDiligenceCcLogSuspenseQueryHookResult = ReturnType<typeof useGetInvestorDiligenceCcLogSuspenseQuery>;
export type GetInvestorDiligenceCcLogQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestorDiligenceCcLogQuery, GraphqlTypes.GetInvestorDiligenceCcLogQueryVariables>;
export const GetProspectDocument = gql`
    query GetProspect($arenaId: ID!, $id: ID!) {
  prospectCcTools(arenaId: $arenaId, id: $id) {
    id
    subscription {
      ...SubscriptionCCLogDumpFields
    }
  }
}
    ${SubscriptionCcLogDumpFieldsFragmentDoc}`;

/**
 * __useGetProspectQuery__
 *
 * To run a query within a React component, call `useGetProspectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProspectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProspectQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProspectQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProspectQuery, GraphqlTypes.GetProspectQueryVariables> & ({ variables: GraphqlTypes.GetProspectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProspectQuery, GraphqlTypes.GetProspectQueryVariables>(GetProspectDocument, options);
      }
export function useGetProspectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProspectQuery, GraphqlTypes.GetProspectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProspectQuery, GraphqlTypes.GetProspectQueryVariables>(GetProspectDocument, options);
        }
// @ts-ignore
export function useGetProspectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectQuery, GraphqlTypes.GetProspectQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProspectQuery, GraphqlTypes.GetProspectQueryVariables>;
export function useGetProspectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectQuery, GraphqlTypes.GetProspectQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProspectQuery | undefined, GraphqlTypes.GetProspectQueryVariables>;
export function useGetProspectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectQuery, GraphqlTypes.GetProspectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProspectQuery, GraphqlTypes.GetProspectQueryVariables>(GetProspectDocument, options);
        }
export type GetProspectQueryHookResult = ReturnType<typeof useGetProspectQuery>;
export type GetProspectLazyQueryHookResult = ReturnType<typeof useGetProspectLazyQuery>;
export type GetProspectSuspenseQueryHookResult = ReturnType<typeof useGetProspectSuspenseQuery>;
export type GetProspectQueryResult = Apollo.QueryResult<GraphqlTypes.GetProspectQuery, GraphqlTypes.GetProspectQueryVariables>;
export const BulkPositionCreationArenasDocument = gql`
    query BulkPositionCreationArenas($cursor: String, $first: Int) {
  arenas(first: $first, after: $cursor, sort: NAME_ASC) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        name
        domain
      }
    }
    count
  }
}
    `;

/**
 * __useBulkPositionCreationArenasQuery__
 *
 * To run a query within a React component, call `useBulkPositionCreationArenasQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkPositionCreationArenasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkPositionCreationArenasQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useBulkPositionCreationArenasQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.BulkPositionCreationArenasQuery, GraphqlTypes.BulkPositionCreationArenasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.BulkPositionCreationArenasQuery, GraphqlTypes.BulkPositionCreationArenasQueryVariables>(BulkPositionCreationArenasDocument, options);
      }
export function useBulkPositionCreationArenasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.BulkPositionCreationArenasQuery, GraphqlTypes.BulkPositionCreationArenasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.BulkPositionCreationArenasQuery, GraphqlTypes.BulkPositionCreationArenasQueryVariables>(BulkPositionCreationArenasDocument, options);
        }
// @ts-ignore
export function useBulkPositionCreationArenasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkPositionCreationArenasQuery, GraphqlTypes.BulkPositionCreationArenasQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.BulkPositionCreationArenasQuery, GraphqlTypes.BulkPositionCreationArenasQueryVariables>;
export function useBulkPositionCreationArenasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkPositionCreationArenasQuery, GraphqlTypes.BulkPositionCreationArenasQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.BulkPositionCreationArenasQuery | undefined, GraphqlTypes.BulkPositionCreationArenasQueryVariables>;
export function useBulkPositionCreationArenasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkPositionCreationArenasQuery, GraphqlTypes.BulkPositionCreationArenasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.BulkPositionCreationArenasQuery, GraphqlTypes.BulkPositionCreationArenasQueryVariables>(BulkPositionCreationArenasDocument, options);
        }
export type BulkPositionCreationArenasQueryHookResult = ReturnType<typeof useBulkPositionCreationArenasQuery>;
export type BulkPositionCreationArenasLazyQueryHookResult = ReturnType<typeof useBulkPositionCreationArenasLazyQuery>;
export type BulkPositionCreationArenasSuspenseQueryHookResult = ReturnType<typeof useBulkPositionCreationArenasSuspenseQuery>;
export type BulkPositionCreationArenasQueryResult = Apollo.QueryResult<GraphqlTypes.BulkPositionCreationArenasQuery, GraphqlTypes.BulkPositionCreationArenasQueryVariables>;
export const BulkPositionCreationEntitiesDocument = gql`
    query BulkPositionCreationEntities($arenaId: ID!) {
  investmentEntitiesByArena(
    arenaId: $arenaId
    filterEntitiesWithTransactions: false
  ) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useBulkPositionCreationEntitiesQuery__
 *
 * To run a query within a React component, call `useBulkPositionCreationEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkPositionCreationEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkPositionCreationEntitiesQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useBulkPositionCreationEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.BulkPositionCreationEntitiesQuery, GraphqlTypes.BulkPositionCreationEntitiesQueryVariables> & ({ variables: GraphqlTypes.BulkPositionCreationEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.BulkPositionCreationEntitiesQuery, GraphqlTypes.BulkPositionCreationEntitiesQueryVariables>(BulkPositionCreationEntitiesDocument, options);
      }
export function useBulkPositionCreationEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.BulkPositionCreationEntitiesQuery, GraphqlTypes.BulkPositionCreationEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.BulkPositionCreationEntitiesQuery, GraphqlTypes.BulkPositionCreationEntitiesQueryVariables>(BulkPositionCreationEntitiesDocument, options);
        }
// @ts-ignore
export function useBulkPositionCreationEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkPositionCreationEntitiesQuery, GraphqlTypes.BulkPositionCreationEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.BulkPositionCreationEntitiesQuery, GraphqlTypes.BulkPositionCreationEntitiesQueryVariables>;
export function useBulkPositionCreationEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkPositionCreationEntitiesQuery, GraphqlTypes.BulkPositionCreationEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.BulkPositionCreationEntitiesQuery | undefined, GraphqlTypes.BulkPositionCreationEntitiesQueryVariables>;
export function useBulkPositionCreationEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkPositionCreationEntitiesQuery, GraphqlTypes.BulkPositionCreationEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.BulkPositionCreationEntitiesQuery, GraphqlTypes.BulkPositionCreationEntitiesQueryVariables>(BulkPositionCreationEntitiesDocument, options);
        }
export type BulkPositionCreationEntitiesQueryHookResult = ReturnType<typeof useBulkPositionCreationEntitiesQuery>;
export type BulkPositionCreationEntitiesLazyQueryHookResult = ReturnType<typeof useBulkPositionCreationEntitiesLazyQuery>;
export type BulkPositionCreationEntitiesSuspenseQueryHookResult = ReturnType<typeof useBulkPositionCreationEntitiesSuspenseQuery>;
export type BulkPositionCreationEntitiesQueryResult = Apollo.QueryResult<GraphqlTypes.BulkPositionCreationEntitiesQuery, GraphqlTypes.BulkPositionCreationEntitiesQueryVariables>;
export const ArenaTransactionsExportDocument = gql`
    mutation ArenaTransactionsExport($arenaTransactionsExportInput: ArenaTransactionsExportInput!) {
  transactionOps {
    arenaTransactionsExport(
      arenaTransactionsExportInput: $arenaTransactionsExportInput
    ) {
      job {
        id
      }
    }
  }
}
    `;
export type ArenaTransactionsExportMutationFn = Apollo.MutationFunction<GraphqlTypes.ArenaTransactionsExportMutation, GraphqlTypes.ArenaTransactionsExportMutationVariables>;

/**
 * __useArenaTransactionsExportMutation__
 *
 * To run a mutation, you first call `useArenaTransactionsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArenaTransactionsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arenaTransactionsExportMutation, { data, loading, error }] = useArenaTransactionsExportMutation({
 *   variables: {
 *      arenaTransactionsExportInput: // value for 'arenaTransactionsExportInput'
 *   },
 * });
 */
export function useArenaTransactionsExportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ArenaTransactionsExportMutation, GraphqlTypes.ArenaTransactionsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ArenaTransactionsExportMutation, GraphqlTypes.ArenaTransactionsExportMutationVariables>(ArenaTransactionsExportDocument, options);
      }
export type ArenaTransactionsExportMutationHookResult = ReturnType<typeof useArenaTransactionsExportMutation>;
export type ArenaTransactionsExportMutationResult = Apollo.MutationResult<GraphqlTypes.ArenaTransactionsExportMutation>;
export type ArenaTransactionsExportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ArenaTransactionsExportMutation, GraphqlTypes.ArenaTransactionsExportMutationVariables>;
export const GetArenaTransactionExportJobsDocument = gql`
    query GetArenaTransactionExportJobs($first: Int = 10) {
  arenaTransactionExportJobs(first: $first) {
    edges {
      node {
        id
        data
        status
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetArenaTransactionExportJobsQuery__
 *
 * To run a query within a React component, call `useGetArenaTransactionExportJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenaTransactionExportJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenaTransactionExportJobsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetArenaTransactionExportJobsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetArenaTransactionExportJobsQuery, GraphqlTypes.GetArenaTransactionExportJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenaTransactionExportJobsQuery, GraphqlTypes.GetArenaTransactionExportJobsQueryVariables>(GetArenaTransactionExportJobsDocument, options);
      }
export function useGetArenaTransactionExportJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenaTransactionExportJobsQuery, GraphqlTypes.GetArenaTransactionExportJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenaTransactionExportJobsQuery, GraphqlTypes.GetArenaTransactionExportJobsQueryVariables>(GetArenaTransactionExportJobsDocument, options);
        }
// @ts-ignore
export function useGetArenaTransactionExportJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaTransactionExportJobsQuery, GraphqlTypes.GetArenaTransactionExportJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaTransactionExportJobsQuery, GraphqlTypes.GetArenaTransactionExportJobsQueryVariables>;
export function useGetArenaTransactionExportJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaTransactionExportJobsQuery, GraphqlTypes.GetArenaTransactionExportJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaTransactionExportJobsQuery | undefined, GraphqlTypes.GetArenaTransactionExportJobsQueryVariables>;
export function useGetArenaTransactionExportJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaTransactionExportJobsQuery, GraphqlTypes.GetArenaTransactionExportJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenaTransactionExportJobsQuery, GraphqlTypes.GetArenaTransactionExportJobsQueryVariables>(GetArenaTransactionExportJobsDocument, options);
        }
export type GetArenaTransactionExportJobsQueryHookResult = ReturnType<typeof useGetArenaTransactionExportJobsQuery>;
export type GetArenaTransactionExportJobsLazyQueryHookResult = ReturnType<typeof useGetArenaTransactionExportJobsLazyQuery>;
export type GetArenaTransactionExportJobsSuspenseQueryHookResult = ReturnType<typeof useGetArenaTransactionExportJobsSuspenseQuery>;
export type GetArenaTransactionExportJobsQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenaTransactionExportJobsQuery, GraphqlTypes.GetArenaTransactionExportJobsQueryVariables>;
export const GetContactsViewedDocumentDocument = gql`
    query GetContactsViewedDocument($arenaId: ID!, $documentId: ID!, $start: String, $end: String, $version: Int) {
  contactsViewedDocument(
    arenaId: $arenaId
    documentId: $documentId
    startDate: $start
    endDate: $end
    version: $version
  ) {
    contactId
    firstName
    lastName
    email
    firstView
    lastView
    viewType
  }
}
    `;

/**
 * __useGetContactsViewedDocumentQuery__
 *
 * To run a query within a React component, call `useGetContactsViewedDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsViewedDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsViewedDocumentQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      documentId: // value for 'documentId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetContactsViewedDocumentQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactsViewedDocumentQuery, GraphqlTypes.GetContactsViewedDocumentQueryVariables> & ({ variables: GraphqlTypes.GetContactsViewedDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactsViewedDocumentQuery, GraphqlTypes.GetContactsViewedDocumentQueryVariables>(GetContactsViewedDocumentDocument, options);
      }
export function useGetContactsViewedDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactsViewedDocumentQuery, GraphqlTypes.GetContactsViewedDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactsViewedDocumentQuery, GraphqlTypes.GetContactsViewedDocumentQueryVariables>(GetContactsViewedDocumentDocument, options);
        }
// @ts-ignore
export function useGetContactsViewedDocumentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsViewedDocumentQuery, GraphqlTypes.GetContactsViewedDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsViewedDocumentQuery, GraphqlTypes.GetContactsViewedDocumentQueryVariables>;
export function useGetContactsViewedDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsViewedDocumentQuery, GraphqlTypes.GetContactsViewedDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsViewedDocumentQuery | undefined, GraphqlTypes.GetContactsViewedDocumentQueryVariables>;
export function useGetContactsViewedDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsViewedDocumentQuery, GraphqlTypes.GetContactsViewedDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactsViewedDocumentQuery, GraphqlTypes.GetContactsViewedDocumentQueryVariables>(GetContactsViewedDocumentDocument, options);
        }
export type GetContactsViewedDocumentQueryHookResult = ReturnType<typeof useGetContactsViewedDocumentQuery>;
export type GetContactsViewedDocumentLazyQueryHookResult = ReturnType<typeof useGetContactsViewedDocumentLazyQuery>;
export type GetContactsViewedDocumentSuspenseQueryHookResult = ReturnType<typeof useGetContactsViewedDocumentSuspenseQuery>;
export type GetContactsViewedDocumentQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactsViewedDocumentQuery, GraphqlTypes.GetContactsViewedDocumentQueryVariables>;
export const MergeDocumentCategoriesDocument = gql`
    mutation mergeDocumentCategories($input: MergeDocumentCategoriesInput!) {
  documentCategoryOps {
    mergeDocumentCategories(objectInput: $input) {
      job {
        id
      }
    }
  }
}
    `;
export type MergeDocumentCategoriesMutationFn = Apollo.MutationFunction<GraphqlTypes.MergeDocumentCategoriesMutation, GraphqlTypes.MergeDocumentCategoriesMutationVariables>;

/**
 * __useMergeDocumentCategoriesMutation__
 *
 * To run a mutation, you first call `useMergeDocumentCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeDocumentCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeDocumentCategoriesMutation, { data, loading, error }] = useMergeDocumentCategoriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeDocumentCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.MergeDocumentCategoriesMutation, GraphqlTypes.MergeDocumentCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.MergeDocumentCategoriesMutation, GraphqlTypes.MergeDocumentCategoriesMutationVariables>(MergeDocumentCategoriesDocument, options);
      }
export type MergeDocumentCategoriesMutationHookResult = ReturnType<typeof useMergeDocumentCategoriesMutation>;
export type MergeDocumentCategoriesMutationResult = Apollo.MutationResult<GraphqlTypes.MergeDocumentCategoriesMutation>;
export type MergeDocumentCategoriesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.MergeDocumentCategoriesMutation, GraphqlTypes.MergeDocumentCategoriesMutationVariables>;
export const GetInvestmentEntitiesByArenaLegacyDocument = gql`
    query GetInvestmentEntitiesByArenaLegacy($arenaId: ID, $filterEntitiesWithTransactions: Boolean = true, $first: Int = 500) {
  investmentEntitiesByArena(
    arenaId: $arenaId
    filterEntitiesWithTransactions: $filterEntitiesWithTransactions
    first: $first
  ) {
    edges {
      node {
        ...EntityFields
      }
    }
  }
}
    ${EntityFieldsFragmentDoc}`;

/**
 * __useGetInvestmentEntitiesByArenaLegacyQuery__
 *
 * To run a query within a React component, call `useGetInvestmentEntitiesByArenaLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentEntitiesByArenaLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentEntitiesByArenaLegacyQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      filterEntitiesWithTransactions: // value for 'filterEntitiesWithTransactions'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetInvestmentEntitiesByArenaLegacyQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQuery, GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQuery, GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQueryVariables>(GetInvestmentEntitiesByArenaLegacyDocument, options);
      }
export function useGetInvestmentEntitiesByArenaLegacyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQuery, GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQuery, GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQueryVariables>(GetInvestmentEntitiesByArenaLegacyDocument, options);
        }
// @ts-ignore
export function useGetInvestmentEntitiesByArenaLegacySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQuery, GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQuery, GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQueryVariables>;
export function useGetInvestmentEntitiesByArenaLegacySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQuery, GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQuery | undefined, GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQueryVariables>;
export function useGetInvestmentEntitiesByArenaLegacySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQuery, GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQuery, GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQueryVariables>(GetInvestmentEntitiesByArenaLegacyDocument, options);
        }
export type GetInvestmentEntitiesByArenaLegacyQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesByArenaLegacyQuery>;
export type GetInvestmentEntitiesByArenaLegacyLazyQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesByArenaLegacyLazyQuery>;
export type GetInvestmentEntitiesByArenaLegacySuspenseQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesByArenaLegacySuspenseQuery>;
export type GetInvestmentEntitiesByArenaLegacyQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQuery, GraphqlTypes.GetInvestmentEntitiesByArenaLegacyQueryVariables>;
export const TransactionDeletionFieldsDocument = gql`
    mutation TransactionDeletionFields($input: TransactionsDeletionFieldsInput!) {
  transactionDeletionFields(deletionInput: $input) {
    result {
      __typename
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on AsyncJobObjectType {
        id
      }
    }
  }
}
    `;
export type TransactionDeletionFieldsMutationFn = Apollo.MutationFunction<GraphqlTypes.TransactionDeletionFieldsMutation, GraphqlTypes.TransactionDeletionFieldsMutationVariables>;

/**
 * __useTransactionDeletionFieldsMutation__
 *
 * To run a mutation, you first call `useTransactionDeletionFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransactionDeletionFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transactionDeletionFieldsMutation, { data, loading, error }] = useTransactionDeletionFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransactionDeletionFieldsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.TransactionDeletionFieldsMutation, GraphqlTypes.TransactionDeletionFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.TransactionDeletionFieldsMutation, GraphqlTypes.TransactionDeletionFieldsMutationVariables>(TransactionDeletionFieldsDocument, options);
      }
export type TransactionDeletionFieldsMutationHookResult = ReturnType<typeof useTransactionDeletionFieldsMutation>;
export type TransactionDeletionFieldsMutationResult = Apollo.MutationResult<GraphqlTypes.TransactionDeletionFieldsMutation>;
export type TransactionDeletionFieldsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.TransactionDeletionFieldsMutation, GraphqlTypes.TransactionDeletionFieldsMutationVariables>;
export const GetArenaTransactionTypesDocument = gql`
    query GetArenaTransactionTypes($arenaId: ID!, $entityIds: [ID]!) {
  arenaTransactionTypes(arenaId: $arenaId, entityIds: $entityIds) {
    id
    name
    model
  }
}
    `;

/**
 * __useGetArenaTransactionTypesQuery__
 *
 * To run a query within a React component, call `useGetArenaTransactionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenaTransactionTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenaTransactionTypesQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useGetArenaTransactionTypesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetArenaTransactionTypesQuery, GraphqlTypes.GetArenaTransactionTypesQueryVariables> & ({ variables: GraphqlTypes.GetArenaTransactionTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenaTransactionTypesQuery, GraphqlTypes.GetArenaTransactionTypesQueryVariables>(GetArenaTransactionTypesDocument, options);
      }
export function useGetArenaTransactionTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenaTransactionTypesQuery, GraphqlTypes.GetArenaTransactionTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenaTransactionTypesQuery, GraphqlTypes.GetArenaTransactionTypesQueryVariables>(GetArenaTransactionTypesDocument, options);
        }
// @ts-ignore
export function useGetArenaTransactionTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaTransactionTypesQuery, GraphqlTypes.GetArenaTransactionTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaTransactionTypesQuery, GraphqlTypes.GetArenaTransactionTypesQueryVariables>;
export function useGetArenaTransactionTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaTransactionTypesQuery, GraphqlTypes.GetArenaTransactionTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaTransactionTypesQuery | undefined, GraphqlTypes.GetArenaTransactionTypesQueryVariables>;
export function useGetArenaTransactionTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaTransactionTypesQuery, GraphqlTypes.GetArenaTransactionTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenaTransactionTypesQuery, GraphqlTypes.GetArenaTransactionTypesQueryVariables>(GetArenaTransactionTypesDocument, options);
        }
export type GetArenaTransactionTypesQueryHookResult = ReturnType<typeof useGetArenaTransactionTypesQuery>;
export type GetArenaTransactionTypesLazyQueryHookResult = ReturnType<typeof useGetArenaTransactionTypesLazyQuery>;
export type GetArenaTransactionTypesSuspenseQueryHookResult = ReturnType<typeof useGetArenaTransactionTypesSuspenseQuery>;
export type GetArenaTransactionTypesQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenaTransactionTypesQuery, GraphqlTypes.GetArenaTransactionTypesQueryVariables>;
export const GetTransactionAllocationTypesDocument = gql`
    query GetTransactionAllocationTypes($arenaId: ID!, $transactionTypeId: ID!, $entityIds: [ID]!) {
  transactionAllocationTypes(
    arenaId: $arenaId
    transactionTypeId: $transactionTypeId
    entityIds: $entityIds
  ) {
    id
    name
  }
}
    `;

/**
 * __useGetTransactionAllocationTypesQuery__
 *
 * To run a query within a React component, call `useGetTransactionAllocationTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionAllocationTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionAllocationTypesQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      transactionTypeId: // value for 'transactionTypeId'
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useGetTransactionAllocationTypesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetTransactionAllocationTypesQuery, GraphqlTypes.GetTransactionAllocationTypesQueryVariables> & ({ variables: GraphqlTypes.GetTransactionAllocationTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTransactionAllocationTypesQuery, GraphqlTypes.GetTransactionAllocationTypesQueryVariables>(GetTransactionAllocationTypesDocument, options);
      }
export function useGetTransactionAllocationTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTransactionAllocationTypesQuery, GraphqlTypes.GetTransactionAllocationTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTransactionAllocationTypesQuery, GraphqlTypes.GetTransactionAllocationTypesQueryVariables>(GetTransactionAllocationTypesDocument, options);
        }
// @ts-ignore
export function useGetTransactionAllocationTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionAllocationTypesQuery, GraphqlTypes.GetTransactionAllocationTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransactionAllocationTypesQuery, GraphqlTypes.GetTransactionAllocationTypesQueryVariables>;
export function useGetTransactionAllocationTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionAllocationTypesQuery, GraphqlTypes.GetTransactionAllocationTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransactionAllocationTypesQuery | undefined, GraphqlTypes.GetTransactionAllocationTypesQueryVariables>;
export function useGetTransactionAllocationTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionAllocationTypesQuery, GraphqlTypes.GetTransactionAllocationTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTransactionAllocationTypesQuery, GraphqlTypes.GetTransactionAllocationTypesQueryVariables>(GetTransactionAllocationTypesDocument, options);
        }
export type GetTransactionAllocationTypesQueryHookResult = ReturnType<typeof useGetTransactionAllocationTypesQuery>;
export type GetTransactionAllocationTypesLazyQueryHookResult = ReturnType<typeof useGetTransactionAllocationTypesLazyQuery>;
export type GetTransactionAllocationTypesSuspenseQueryHookResult = ReturnType<typeof useGetTransactionAllocationTypesSuspenseQuery>;
export type GetTransactionAllocationTypesQueryResult = Apollo.QueryResult<GraphqlTypes.GetTransactionAllocationTypesQuery, GraphqlTypes.GetTransactionAllocationTypesQueryVariables>;
export const GetTransactionsDeletionUrlDocument = gql`
    query GetTransactionsDeletionUrl($asyncJobId: ID!) {
  transactionDeletionUrl(asyncJobId: $asyncJobId)
}
    `;

/**
 * __useGetTransactionsDeletionUrlQuery__
 *
 * To run a query within a React component, call `useGetTransactionsDeletionUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsDeletionUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsDeletionUrlQuery({
 *   variables: {
 *      asyncJobId: // value for 'asyncJobId'
 *   },
 * });
 */
export function useGetTransactionsDeletionUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetTransactionsDeletionUrlQuery, GraphqlTypes.GetTransactionsDeletionUrlQueryVariables> & ({ variables: GraphqlTypes.GetTransactionsDeletionUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTransactionsDeletionUrlQuery, GraphqlTypes.GetTransactionsDeletionUrlQueryVariables>(GetTransactionsDeletionUrlDocument, options);
      }
export function useGetTransactionsDeletionUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTransactionsDeletionUrlQuery, GraphqlTypes.GetTransactionsDeletionUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTransactionsDeletionUrlQuery, GraphqlTypes.GetTransactionsDeletionUrlQueryVariables>(GetTransactionsDeletionUrlDocument, options);
        }
// @ts-ignore
export function useGetTransactionsDeletionUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionsDeletionUrlQuery, GraphqlTypes.GetTransactionsDeletionUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransactionsDeletionUrlQuery, GraphqlTypes.GetTransactionsDeletionUrlQueryVariables>;
export function useGetTransactionsDeletionUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionsDeletionUrlQuery, GraphqlTypes.GetTransactionsDeletionUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransactionsDeletionUrlQuery | undefined, GraphqlTypes.GetTransactionsDeletionUrlQueryVariables>;
export function useGetTransactionsDeletionUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionsDeletionUrlQuery, GraphqlTypes.GetTransactionsDeletionUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTransactionsDeletionUrlQuery, GraphqlTypes.GetTransactionsDeletionUrlQueryVariables>(GetTransactionsDeletionUrlDocument, options);
        }
export type GetTransactionsDeletionUrlQueryHookResult = ReturnType<typeof useGetTransactionsDeletionUrlQuery>;
export type GetTransactionsDeletionUrlLazyQueryHookResult = ReturnType<typeof useGetTransactionsDeletionUrlLazyQuery>;
export type GetTransactionsDeletionUrlSuspenseQueryHookResult = ReturnType<typeof useGetTransactionsDeletionUrlSuspenseQuery>;
export type GetTransactionsDeletionUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetTransactionsDeletionUrlQuery, GraphqlTypes.GetTransactionsDeletionUrlQueryVariables>;
export const GetTransactionDescriptionsDocument = gql`
    query GetTransactionDescriptions($arenaId: ID!, $id: ID!, $transactionTypeId: ID!, $entityId: ID!, $isBatch: Boolean!) {
  transactionDescription(
    arenaId: $arenaId
    id: $id
    transactionTypeId: $transactionTypeId
    entityId: $entityId
    isBatch: $isBatch
  ) {
    ...TransactionDescriptionFields
  }
}
    ${TransactionDescriptionFieldsFragmentDoc}`;

/**
 * __useGetTransactionDescriptionsQuery__
 *
 * To run a query within a React component, call `useGetTransactionDescriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionDescriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionDescriptionsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      id: // value for 'id'
 *      transactionTypeId: // value for 'transactionTypeId'
 *      entityId: // value for 'entityId'
 *      isBatch: // value for 'isBatch'
 *   },
 * });
 */
export function useGetTransactionDescriptionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetTransactionDescriptionsQuery, GraphqlTypes.GetTransactionDescriptionsQueryVariables> & ({ variables: GraphqlTypes.GetTransactionDescriptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTransactionDescriptionsQuery, GraphqlTypes.GetTransactionDescriptionsQueryVariables>(GetTransactionDescriptionsDocument, options);
      }
export function useGetTransactionDescriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTransactionDescriptionsQuery, GraphqlTypes.GetTransactionDescriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTransactionDescriptionsQuery, GraphqlTypes.GetTransactionDescriptionsQueryVariables>(GetTransactionDescriptionsDocument, options);
        }
// @ts-ignore
export function useGetTransactionDescriptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionDescriptionsQuery, GraphqlTypes.GetTransactionDescriptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransactionDescriptionsQuery, GraphqlTypes.GetTransactionDescriptionsQueryVariables>;
export function useGetTransactionDescriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionDescriptionsQuery, GraphqlTypes.GetTransactionDescriptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransactionDescriptionsQuery | undefined, GraphqlTypes.GetTransactionDescriptionsQueryVariables>;
export function useGetTransactionDescriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionDescriptionsQuery, GraphqlTypes.GetTransactionDescriptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTransactionDescriptionsQuery, GraphqlTypes.GetTransactionDescriptionsQueryVariables>(GetTransactionDescriptionsDocument, options);
        }
export type GetTransactionDescriptionsQueryHookResult = ReturnType<typeof useGetTransactionDescriptionsQuery>;
export type GetTransactionDescriptionsLazyQueryHookResult = ReturnType<typeof useGetTransactionDescriptionsLazyQuery>;
export type GetTransactionDescriptionsSuspenseQueryHookResult = ReturnType<typeof useGetTransactionDescriptionsSuspenseQuery>;
export type GetTransactionDescriptionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetTransactionDescriptionsQuery, GraphqlTypes.GetTransactionDescriptionsQueryVariables>;
export const FeatureFlagAuditQueryDocument = gql`
    query FeatureFlagAuditQuery($afterCursor: String) {
  logs(ofType: feature_flag, first: 100, after: $afterCursor) {
    pageInfo {
      endCursor
      hasNextPage
    }
    count
    edges {
      node {
        id
        user {
          fullName
          emailAddress
        }
        eventTime
        eventData {
          name
          enabled
        }
      }
    }
  }
}
    `;

/**
 * __useFeatureFlagAuditQueryQuery__
 *
 * To run a query within a React component, call `useFeatureFlagAuditQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagAuditQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagAuditQueryQuery({
 *   variables: {
 *      afterCursor: // value for 'afterCursor'
 *   },
 * });
 */
export function useFeatureFlagAuditQueryQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.FeatureFlagAuditQueryQuery, GraphqlTypes.FeatureFlagAuditQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.FeatureFlagAuditQueryQuery, GraphqlTypes.FeatureFlagAuditQueryQueryVariables>(FeatureFlagAuditQueryDocument, options);
      }
export function useFeatureFlagAuditQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.FeatureFlagAuditQueryQuery, GraphqlTypes.FeatureFlagAuditQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.FeatureFlagAuditQueryQuery, GraphqlTypes.FeatureFlagAuditQueryQueryVariables>(FeatureFlagAuditQueryDocument, options);
        }
// @ts-ignore
export function useFeatureFlagAuditQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.FeatureFlagAuditQueryQuery, GraphqlTypes.FeatureFlagAuditQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FeatureFlagAuditQueryQuery, GraphqlTypes.FeatureFlagAuditQueryQueryVariables>;
export function useFeatureFlagAuditQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FeatureFlagAuditQueryQuery, GraphqlTypes.FeatureFlagAuditQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FeatureFlagAuditQueryQuery | undefined, GraphqlTypes.FeatureFlagAuditQueryQueryVariables>;
export function useFeatureFlagAuditQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FeatureFlagAuditQueryQuery, GraphqlTypes.FeatureFlagAuditQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.FeatureFlagAuditQueryQuery, GraphqlTypes.FeatureFlagAuditQueryQueryVariables>(FeatureFlagAuditQueryDocument, options);
        }
export type FeatureFlagAuditQueryQueryHookResult = ReturnType<typeof useFeatureFlagAuditQueryQuery>;
export type FeatureFlagAuditQueryLazyQueryHookResult = ReturnType<typeof useFeatureFlagAuditQueryLazyQuery>;
export type FeatureFlagAuditQuerySuspenseQueryHookResult = ReturnType<typeof useFeatureFlagAuditQuerySuspenseQuery>;
export type FeatureFlagAuditQueryQueryResult = Apollo.QueryResult<GraphqlTypes.FeatureFlagAuditQueryQuery, GraphqlTypes.FeatureFlagAuditQueryQueryVariables>;
export const UpdateDevFeatureFlagsDocument = gql`
    mutation UpdateDevFeatureFlags($flags: [UpdateFeatureFlagInput!]) {
  updateFeatureFlags(flags: $flags) {
    flags {
      name
      enabled
    }
  }
}
    `;
export type UpdateDevFeatureFlagsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateDevFeatureFlagsMutation, GraphqlTypes.UpdateDevFeatureFlagsMutationVariables>;

/**
 * __useUpdateDevFeatureFlagsMutation__
 *
 * To run a mutation, you first call `useUpdateDevFeatureFlagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDevFeatureFlagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDevFeatureFlagsMutation, { data, loading, error }] = useUpdateDevFeatureFlagsMutation({
 *   variables: {
 *      flags: // value for 'flags'
 *   },
 * });
 */
export function useUpdateDevFeatureFlagsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateDevFeatureFlagsMutation, GraphqlTypes.UpdateDevFeatureFlagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateDevFeatureFlagsMutation, GraphqlTypes.UpdateDevFeatureFlagsMutationVariables>(UpdateDevFeatureFlagsDocument, options);
      }
export type UpdateDevFeatureFlagsMutationHookResult = ReturnType<typeof useUpdateDevFeatureFlagsMutation>;
export type UpdateDevFeatureFlagsMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateDevFeatureFlagsMutation>;
export type UpdateDevFeatureFlagsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateDevFeatureFlagsMutation, GraphqlTypes.UpdateDevFeatureFlagsMutationVariables>;
export const DevFeatureFlagsDocument = gql`
    query DevFeatureFlags {
  flags {
    name
    type
    typeId
    enabled
  }
}
    `;

/**
 * __useDevFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useDevFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDevFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.DevFeatureFlagsQuery, GraphqlTypes.DevFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.DevFeatureFlagsQuery, GraphqlTypes.DevFeatureFlagsQueryVariables>(DevFeatureFlagsDocument, options);
      }
export function useDevFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.DevFeatureFlagsQuery, GraphqlTypes.DevFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.DevFeatureFlagsQuery, GraphqlTypes.DevFeatureFlagsQueryVariables>(DevFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useDevFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.DevFeatureFlagsQuery, GraphqlTypes.DevFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DevFeatureFlagsQuery, GraphqlTypes.DevFeatureFlagsQueryVariables>;
export function useDevFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DevFeatureFlagsQuery, GraphqlTypes.DevFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DevFeatureFlagsQuery | undefined, GraphqlTypes.DevFeatureFlagsQueryVariables>;
export function useDevFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DevFeatureFlagsQuery, GraphqlTypes.DevFeatureFlagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.DevFeatureFlagsQuery, GraphqlTypes.DevFeatureFlagsQueryVariables>(DevFeatureFlagsDocument, options);
        }
export type DevFeatureFlagsQueryHookResult = ReturnType<typeof useDevFeatureFlagsQuery>;
export type DevFeatureFlagsLazyQueryHookResult = ReturnType<typeof useDevFeatureFlagsLazyQuery>;
export type DevFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useDevFeatureFlagsSuspenseQuery>;
export type DevFeatureFlagsQueryResult = Apollo.QueryResult<GraphqlTypes.DevFeatureFlagsQuery, GraphqlTypes.DevFeatureFlagsQueryVariables>;
export const GetEmailDistributionListsForEditArenaDocument = gql`
    query getEmailDistributionListsForEditArena($arenaId: ID) {
  emailDistributionLists(arenaId: $arenaId) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetEmailDistributionListsForEditArenaQuery__
 *
 * To run a query within a React component, call `useGetEmailDistributionListsForEditArenaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailDistributionListsForEditArenaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailDistributionListsForEditArenaQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetEmailDistributionListsForEditArenaQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEmailDistributionListsForEditArenaQuery, GraphqlTypes.GetEmailDistributionListsForEditArenaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEmailDistributionListsForEditArenaQuery, GraphqlTypes.GetEmailDistributionListsForEditArenaQueryVariables>(GetEmailDistributionListsForEditArenaDocument, options);
      }
export function useGetEmailDistributionListsForEditArenaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEmailDistributionListsForEditArenaQuery, GraphqlTypes.GetEmailDistributionListsForEditArenaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEmailDistributionListsForEditArenaQuery, GraphqlTypes.GetEmailDistributionListsForEditArenaQueryVariables>(GetEmailDistributionListsForEditArenaDocument, options);
        }
// @ts-ignore
export function useGetEmailDistributionListsForEditArenaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailDistributionListsForEditArenaQuery, GraphqlTypes.GetEmailDistributionListsForEditArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailDistributionListsForEditArenaQuery, GraphqlTypes.GetEmailDistributionListsForEditArenaQueryVariables>;
export function useGetEmailDistributionListsForEditArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailDistributionListsForEditArenaQuery, GraphqlTypes.GetEmailDistributionListsForEditArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailDistributionListsForEditArenaQuery | undefined, GraphqlTypes.GetEmailDistributionListsForEditArenaQueryVariables>;
export function useGetEmailDistributionListsForEditArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailDistributionListsForEditArenaQuery, GraphqlTypes.GetEmailDistributionListsForEditArenaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEmailDistributionListsForEditArenaQuery, GraphqlTypes.GetEmailDistributionListsForEditArenaQueryVariables>(GetEmailDistributionListsForEditArenaDocument, options);
        }
export type GetEmailDistributionListsForEditArenaQueryHookResult = ReturnType<typeof useGetEmailDistributionListsForEditArenaQuery>;
export type GetEmailDistributionListsForEditArenaLazyQueryHookResult = ReturnType<typeof useGetEmailDistributionListsForEditArenaLazyQuery>;
export type GetEmailDistributionListsForEditArenaSuspenseQueryHookResult = ReturnType<typeof useGetEmailDistributionListsForEditArenaSuspenseQuery>;
export type GetEmailDistributionListsForEditArenaQueryResult = Apollo.QueryResult<GraphqlTypes.GetEmailDistributionListsForEditArenaQuery, GraphqlTypes.GetEmailDistributionListsForEditArenaQueryVariables>;
export const GetDocumentCategoriesForEditArenaDocument = gql`
    query getDocumentCategoriesForEditArena($arenaId: ID) {
  documentCategoriesCcTools(arenaId: $arenaId) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetDocumentCategoriesForEditArenaQuery__
 *
 * To run a query within a React component, call `useGetDocumentCategoriesForEditArenaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentCategoriesForEditArenaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentCategoriesForEditArenaQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetDocumentCategoriesForEditArenaQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDocumentCategoriesForEditArenaQuery, GraphqlTypes.GetDocumentCategoriesForEditArenaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDocumentCategoriesForEditArenaQuery, GraphqlTypes.GetDocumentCategoriesForEditArenaQueryVariables>(GetDocumentCategoriesForEditArenaDocument, options);
      }
export function useGetDocumentCategoriesForEditArenaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDocumentCategoriesForEditArenaQuery, GraphqlTypes.GetDocumentCategoriesForEditArenaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDocumentCategoriesForEditArenaQuery, GraphqlTypes.GetDocumentCategoriesForEditArenaQueryVariables>(GetDocumentCategoriesForEditArenaDocument, options);
        }
// @ts-ignore
export function useGetDocumentCategoriesForEditArenaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentCategoriesForEditArenaQuery, GraphqlTypes.GetDocumentCategoriesForEditArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentCategoriesForEditArenaQuery, GraphqlTypes.GetDocumentCategoriesForEditArenaQueryVariables>;
export function useGetDocumentCategoriesForEditArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentCategoriesForEditArenaQuery, GraphqlTypes.GetDocumentCategoriesForEditArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentCategoriesForEditArenaQuery | undefined, GraphqlTypes.GetDocumentCategoriesForEditArenaQueryVariables>;
export function useGetDocumentCategoriesForEditArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentCategoriesForEditArenaQuery, GraphqlTypes.GetDocumentCategoriesForEditArenaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDocumentCategoriesForEditArenaQuery, GraphqlTypes.GetDocumentCategoriesForEditArenaQueryVariables>(GetDocumentCategoriesForEditArenaDocument, options);
        }
export type GetDocumentCategoriesForEditArenaQueryHookResult = ReturnType<typeof useGetDocumentCategoriesForEditArenaQuery>;
export type GetDocumentCategoriesForEditArenaLazyQueryHookResult = ReturnType<typeof useGetDocumentCategoriesForEditArenaLazyQuery>;
export type GetDocumentCategoriesForEditArenaSuspenseQueryHookResult = ReturnType<typeof useGetDocumentCategoriesForEditArenaSuspenseQuery>;
export type GetDocumentCategoriesForEditArenaQueryResult = Apollo.QueryResult<GraphqlTypes.GetDocumentCategoriesForEditArenaQuery, GraphqlTypes.GetDocumentCategoriesForEditArenaQueryVariables>;
export const GetArenaDetailsDocument = gql`
    query GetArenaDetails($arenaId: ID!) {
  arena(id: $arenaId) {
    ...ArenaFields
    isActivated
    contactAccessGroups {
      edges {
        node {
          id
          title
        }
      }
    }
    features {
      hasTransferAccounting
      hasPortalInvites
      hasYardiImImport
      hasParallelFunds
      hasSubscriptions
      hasUnifiedLpSubscription
      hasEditableLpPaymentPreferences
      hasAdvancedPermissions
      hasYardiVoyagerIntegration
      hasFundAdmin
      hasCustomerEmailServer
      hasEmailServiceProviderMailgun
      hasOutlookIntegration
      hasAnalytics
      hasInsightEtl
      hasInsightsAi
      insightsExportOnly
      hasNetIncomeSettings
      hasNetAssetValueSettings
      hasOpenEndFundSettings
      hasAccountValuesSettings
      requireLpAccreditationAndPreferences
      supportsComprehensiveAuditLog
      supportsCustomDataFields
      supportsDynamicSubscriptionQuestions
      supportsIlpaNotices
      supportsMultipleNda
      supportsMultipleStationery
      supportsProspectTableCustomization
      supportsTimeWeightedReturn
      supportsWatermarking
      hasAutomatedPayments
      hasDataAccessRoleUse
      hasOperatingCompanies
      hasUnifiedPortalPreview
      hasSso
      hasNewOwnershipTypes
      hasAutoSubscribeLeads
      supportsEntityLevelContacts
      showFundAdminDeliverablesModule
      showFaAccountingTab
      hasGpxIntegration
      hasDynamicSubscriptions
      hasDynamicSubscriptionsCustomSections
      mappingTabAdminSettings
      hasGpxIntegrationExport
      hasProspectOptimization
      hasHubspotIntegration
      hasPreqinIntegration
      hasMarketLensIntegration
      hasGlDataForSoi
      hasLpcmAutomaticUpdateAndRemoval
      hasContactLastUpdateOptimization
      hasCurrencyConversion
      hasExternalAuthentication
      hasEditAndDeleteActivity
      hasZapierIntegration
      hasBankAccountShowSwiftUi
      hasSwiftPayments
      hasBulkCountersign
      hasSubscriptionAiDocumentExtraction
      enableZipValidation
      showOwnershipTabWithNewLogic
      enableWaterfall
      enablePublishToDataFabric
      useDocusignOauthFor2fa
      hasSftpDocumentPosting
      hasReportDashboardM2
      hasCreditAppIntegration
      hasCountersignerGroups
      hasFullCrmSponsor
      hasFullCrmProAndEnterprise
      hasFayBetaEnabled
    }
    settings {
      id
      autoSubscribeLeadsContactAccessGroupId
    }
  }
}
    ${ArenaFieldsFragmentDoc}`;

/**
 * __useGetArenaDetailsQuery__
 *
 * To run a query within a React component, call `useGetArenaDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenaDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenaDetailsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetArenaDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetArenaDetailsQuery, GraphqlTypes.GetArenaDetailsQueryVariables> & ({ variables: GraphqlTypes.GetArenaDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenaDetailsQuery, GraphqlTypes.GetArenaDetailsQueryVariables>(GetArenaDetailsDocument, options);
      }
export function useGetArenaDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenaDetailsQuery, GraphqlTypes.GetArenaDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenaDetailsQuery, GraphqlTypes.GetArenaDetailsQueryVariables>(GetArenaDetailsDocument, options);
        }
// @ts-ignore
export function useGetArenaDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaDetailsQuery, GraphqlTypes.GetArenaDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaDetailsQuery, GraphqlTypes.GetArenaDetailsQueryVariables>;
export function useGetArenaDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaDetailsQuery, GraphqlTypes.GetArenaDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaDetailsQuery | undefined, GraphqlTypes.GetArenaDetailsQueryVariables>;
export function useGetArenaDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaDetailsQuery, GraphqlTypes.GetArenaDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenaDetailsQuery, GraphqlTypes.GetArenaDetailsQueryVariables>(GetArenaDetailsDocument, options);
        }
export type GetArenaDetailsQueryHookResult = ReturnType<typeof useGetArenaDetailsQuery>;
export type GetArenaDetailsLazyQueryHookResult = ReturnType<typeof useGetArenaDetailsLazyQuery>;
export type GetArenaDetailsSuspenseQueryHookResult = ReturnType<typeof useGetArenaDetailsSuspenseQuery>;
export type GetArenaDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenaDetailsQuery, GraphqlTypes.GetArenaDetailsQueryVariables>;
export const GetArenasWithPaginationDocument = gql`
    query GetArenasWithPagination($cursor: String, $first: Int) {
  arenas(first: $first, after: $cursor, sort: NAME_ASC) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        name
        domain
      }
    }
    count
  }
}
    `;

/**
 * __useGetArenasWithPaginationQuery__
 *
 * To run a query within a React component, call `useGetArenasWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenasWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenasWithPaginationQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetArenasWithPaginationQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetArenasWithPaginationQuery, GraphqlTypes.GetArenasWithPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenasWithPaginationQuery, GraphqlTypes.GetArenasWithPaginationQueryVariables>(GetArenasWithPaginationDocument, options);
      }
export function useGetArenasWithPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenasWithPaginationQuery, GraphqlTypes.GetArenasWithPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenasWithPaginationQuery, GraphqlTypes.GetArenasWithPaginationQueryVariables>(GetArenasWithPaginationDocument, options);
        }
// @ts-ignore
export function useGetArenasWithPaginationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasWithPaginationQuery, GraphqlTypes.GetArenasWithPaginationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenasWithPaginationQuery, GraphqlTypes.GetArenasWithPaginationQueryVariables>;
export function useGetArenasWithPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasWithPaginationQuery, GraphqlTypes.GetArenasWithPaginationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenasWithPaginationQuery | undefined, GraphqlTypes.GetArenasWithPaginationQueryVariables>;
export function useGetArenasWithPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasWithPaginationQuery, GraphqlTypes.GetArenasWithPaginationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenasWithPaginationQuery, GraphqlTypes.GetArenasWithPaginationQueryVariables>(GetArenasWithPaginationDocument, options);
        }
export type GetArenasWithPaginationQueryHookResult = ReturnType<typeof useGetArenasWithPaginationQuery>;
export type GetArenasWithPaginationLazyQueryHookResult = ReturnType<typeof useGetArenasWithPaginationLazyQuery>;
export type GetArenasWithPaginationSuspenseQueryHookResult = ReturnType<typeof useGetArenasWithPaginationSuspenseQuery>;
export type GetArenasWithPaginationQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenasWithPaginationQuery, GraphqlTypes.GetArenasWithPaginationQueryVariables>;
export const GetEditionFeatureFlagsDocument = gql`
    query GetEditionFeatureFlags {
  editionFeatureFlags {
    id
    editionName
    hasNetIncomeSettings
    hasNetAssetValueSettings
    hasOpenEndFundSettings
    hasAccountValuesSettings
    hasOutlookIntegration
    hasDataAccessRoleUse
    supportsComprehensiveAuditLog
    supportsCustomDataFields
    supportsDynamicSubscriptionQuestions
    supportsIlpaNotices
    supportsMultipleNda
    supportsMultipleStationery
    supportsProspectTableCustomization
    supportsTimeWeightedReturn
    supportsWatermarking
    hasSso
    hasDynamicSubscriptions
    hasDynamicSubscriptionsCustomSections
    hasCustomerEmailServer
    hasFullCrmSponsor
    hasFullCrmProAndEnterprise
  }
}
    `;

/**
 * __useGetEditionFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetEditionFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditionFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditionFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEditionFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEditionFeatureFlagsQuery, GraphqlTypes.GetEditionFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEditionFeatureFlagsQuery, GraphqlTypes.GetEditionFeatureFlagsQueryVariables>(GetEditionFeatureFlagsDocument, options);
      }
export function useGetEditionFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEditionFeatureFlagsQuery, GraphqlTypes.GetEditionFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEditionFeatureFlagsQuery, GraphqlTypes.GetEditionFeatureFlagsQueryVariables>(GetEditionFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useGetEditionFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditionFeatureFlagsQuery, GraphqlTypes.GetEditionFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEditionFeatureFlagsQuery, GraphqlTypes.GetEditionFeatureFlagsQueryVariables>;
export function useGetEditionFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditionFeatureFlagsQuery, GraphqlTypes.GetEditionFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEditionFeatureFlagsQuery | undefined, GraphqlTypes.GetEditionFeatureFlagsQueryVariables>;
export function useGetEditionFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditionFeatureFlagsQuery, GraphqlTypes.GetEditionFeatureFlagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEditionFeatureFlagsQuery, GraphqlTypes.GetEditionFeatureFlagsQueryVariables>(GetEditionFeatureFlagsDocument, options);
        }
export type GetEditionFeatureFlagsQueryHookResult = ReturnType<typeof useGetEditionFeatureFlagsQuery>;
export type GetEditionFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetEditionFeatureFlagsLazyQuery>;
export type GetEditionFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useGetEditionFeatureFlagsSuspenseQuery>;
export type GetEditionFeatureFlagsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEditionFeatureFlagsQuery, GraphqlTypes.GetEditionFeatureFlagsQueryVariables>;
export const GetUnifiedPortalFeatureFlagDocument = gql`
    query getUnifiedPortalFeatureFlag {
  devFeatures {
    unifiedPortal
  }
}
    `;

/**
 * __useGetUnifiedPortalFeatureFlagQuery__
 *
 * To run a query within a React component, call `useGetUnifiedPortalFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnifiedPortalFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnifiedPortalFeatureFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnifiedPortalFeatureFlagQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>(GetUnifiedPortalFeatureFlagDocument, options);
      }
export function useGetUnifiedPortalFeatureFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>(GetUnifiedPortalFeatureFlagDocument, options);
        }
// @ts-ignore
export function useGetUnifiedPortalFeatureFlagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>;
export function useGetUnifiedPortalFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery | undefined, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>;
export function useGetUnifiedPortalFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>(GetUnifiedPortalFeatureFlagDocument, options);
        }
export type GetUnifiedPortalFeatureFlagQueryHookResult = ReturnType<typeof useGetUnifiedPortalFeatureFlagQuery>;
export type GetUnifiedPortalFeatureFlagLazyQueryHookResult = ReturnType<typeof useGetUnifiedPortalFeatureFlagLazyQuery>;
export type GetUnifiedPortalFeatureFlagSuspenseQueryHookResult = ReturnType<typeof useGetUnifiedPortalFeatureFlagSuspenseQuery>;
export type GetUnifiedPortalFeatureFlagQueryResult = Apollo.QueryResult<GraphqlTypes.GetUnifiedPortalFeatureFlagQuery, GraphqlTypes.GetUnifiedPortalFeatureFlagQueryVariables>;
export const GetEditArenaDevFeatureFlagsDocument = gql`
    query GetEditArenaDevFeatureFlags {
  devFeatures {
    gpxIntegrations
    hubspotIntegration
    lpRequestManagementM1
    enableScheduledEmails
    externalAuthentication
    enableLpEditPaymentPreferenceAdminSettings
    zapierIntegration
    bankAccountSwiftUi
    swiftPayments
    subscriptionBulkCountersign
    preqinIntegration
    subscriptionAiDocumentExtraction
    publishToDataFabric
    sftpDocumentPosting
  }
}
    `;

/**
 * __useGetEditArenaDevFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetEditArenaDevFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditArenaDevFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditArenaDevFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEditArenaDevFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>(GetEditArenaDevFeatureFlagsDocument, options);
      }
export function useGetEditArenaDevFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>(GetEditArenaDevFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useGetEditArenaDevFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>;
export function useGetEditArenaDevFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery | undefined, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>;
export function useGetEditArenaDevFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>(GetEditArenaDevFeatureFlagsDocument, options);
        }
export type GetEditArenaDevFeatureFlagsQueryHookResult = ReturnType<typeof useGetEditArenaDevFeatureFlagsQuery>;
export type GetEditArenaDevFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetEditArenaDevFeatureFlagsLazyQuery>;
export type GetEditArenaDevFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useGetEditArenaDevFeatureFlagsSuspenseQuery>;
export type GetEditArenaDevFeatureFlagsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEditArenaDevFeatureFlagsQuery, GraphqlTypes.GetEditArenaDevFeatureFlagsQueryVariables>;
export const GetArenasSortedByNameDocument = gql`
    query GetArenasSortedByName {
  arenas(sort: NAME_ASC) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetArenasSortedByNameQuery__
 *
 * To run a query within a React component, call `useGetArenasSortedByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenasSortedByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenasSortedByNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetArenasSortedByNameQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetArenasSortedByNameQuery, GraphqlTypes.GetArenasSortedByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenasSortedByNameQuery, GraphqlTypes.GetArenasSortedByNameQueryVariables>(GetArenasSortedByNameDocument, options);
      }
export function useGetArenasSortedByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenasSortedByNameQuery, GraphqlTypes.GetArenasSortedByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenasSortedByNameQuery, GraphqlTypes.GetArenasSortedByNameQueryVariables>(GetArenasSortedByNameDocument, options);
        }
// @ts-ignore
export function useGetArenasSortedByNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasSortedByNameQuery, GraphqlTypes.GetArenasSortedByNameQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenasSortedByNameQuery, GraphqlTypes.GetArenasSortedByNameQueryVariables>;
export function useGetArenasSortedByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasSortedByNameQuery, GraphqlTypes.GetArenasSortedByNameQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenasSortedByNameQuery | undefined, GraphqlTypes.GetArenasSortedByNameQueryVariables>;
export function useGetArenasSortedByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasSortedByNameQuery, GraphqlTypes.GetArenasSortedByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenasSortedByNameQuery, GraphqlTypes.GetArenasSortedByNameQueryVariables>(GetArenasSortedByNameDocument, options);
        }
export type GetArenasSortedByNameQueryHookResult = ReturnType<typeof useGetArenasSortedByNameQuery>;
export type GetArenasSortedByNameLazyQueryHookResult = ReturnType<typeof useGetArenasSortedByNameLazyQuery>;
export type GetArenasSortedByNameSuspenseQueryHookResult = ReturnType<typeof useGetArenasSortedByNameSuspenseQuery>;
export type GetArenasSortedByNameQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenasSortedByNameQuery, GraphqlTypes.GetArenasSortedByNameQueryVariables>;
export const GetSessionLogsDocument = gql`
    query GetSessionLogs($arenaId: ID, $cursor: String, $first: Int = 10) {
  sessionLogs(
    arenaId: $arenaId
    first: $first
    after: $cursor
    sort: START_TIME_DESC
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        arenaId
        user {
          id
          firstName
          lastName
        }
        ipAddress
        startTime
        userAgent
      }
    }
  }
}
    `;

/**
 * __useGetSessionLogsQuery__
 *
 * To run a query within a React component, call `useGetSessionLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionLogsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      cursor: // value for 'cursor'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetSessionLogsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetSessionLogsQuery, GraphqlTypes.GetSessionLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSessionLogsQuery, GraphqlTypes.GetSessionLogsQueryVariables>(GetSessionLogsDocument, options);
      }
export function useGetSessionLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSessionLogsQuery, GraphqlTypes.GetSessionLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSessionLogsQuery, GraphqlTypes.GetSessionLogsQueryVariables>(GetSessionLogsDocument, options);
        }
// @ts-ignore
export function useGetSessionLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSessionLogsQuery, GraphqlTypes.GetSessionLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSessionLogsQuery, GraphqlTypes.GetSessionLogsQueryVariables>;
export function useGetSessionLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSessionLogsQuery, GraphqlTypes.GetSessionLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSessionLogsQuery | undefined, GraphqlTypes.GetSessionLogsQueryVariables>;
export function useGetSessionLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSessionLogsQuery, GraphqlTypes.GetSessionLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSessionLogsQuery, GraphqlTypes.GetSessionLogsQueryVariables>(GetSessionLogsDocument, options);
        }
export type GetSessionLogsQueryHookResult = ReturnType<typeof useGetSessionLogsQuery>;
export type GetSessionLogsLazyQueryHookResult = ReturnType<typeof useGetSessionLogsLazyQuery>;
export type GetSessionLogsSuspenseQueryHookResult = ReturnType<typeof useGetSessionLogsSuspenseQuery>;
export type GetSessionLogsQueryResult = Apollo.QueryResult<GraphqlTypes.GetSessionLogsQuery, GraphqlTypes.GetSessionLogsQueryVariables>;
export const GetArenaInfoByIdDocument = gql`
    query GetArenaInfoById($arenaId: ID!) {
  arenas(arenaIds: [$arenaId]) {
    edges {
      node {
        id
        name
        supportEmail
        supportPhone
      }
    }
  }
}
    `;

/**
 * __useGetArenaInfoByIdQuery__
 *
 * To run a query within a React component, call `useGetArenaInfoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenaInfoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenaInfoByIdQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetArenaInfoByIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetArenaInfoByIdQuery, GraphqlTypes.GetArenaInfoByIdQueryVariables> & ({ variables: GraphqlTypes.GetArenaInfoByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenaInfoByIdQuery, GraphqlTypes.GetArenaInfoByIdQueryVariables>(GetArenaInfoByIdDocument, options);
      }
export function useGetArenaInfoByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenaInfoByIdQuery, GraphqlTypes.GetArenaInfoByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenaInfoByIdQuery, GraphqlTypes.GetArenaInfoByIdQueryVariables>(GetArenaInfoByIdDocument, options);
        }
// @ts-ignore
export function useGetArenaInfoByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaInfoByIdQuery, GraphqlTypes.GetArenaInfoByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaInfoByIdQuery, GraphqlTypes.GetArenaInfoByIdQueryVariables>;
export function useGetArenaInfoByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaInfoByIdQuery, GraphqlTypes.GetArenaInfoByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaInfoByIdQuery | undefined, GraphqlTypes.GetArenaInfoByIdQueryVariables>;
export function useGetArenaInfoByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaInfoByIdQuery, GraphqlTypes.GetArenaInfoByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenaInfoByIdQuery, GraphqlTypes.GetArenaInfoByIdQueryVariables>(GetArenaInfoByIdDocument, options);
        }
export type GetArenaInfoByIdQueryHookResult = ReturnType<typeof useGetArenaInfoByIdQuery>;
export type GetArenaInfoByIdLazyQueryHookResult = ReturnType<typeof useGetArenaInfoByIdLazyQuery>;
export type GetArenaInfoByIdSuspenseQueryHookResult = ReturnType<typeof useGetArenaInfoByIdSuspenseQuery>;
export type GetArenaInfoByIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenaInfoByIdQuery, GraphqlTypes.GetArenaInfoByIdQueryVariables>;
export const GetRecoveryCodesForUserDocument = gql`
    query GetRecoveryCodesForUser($userId: ID!) {
  getUserForCcTools(userId: $userId) {
    id
    twoFaRecoveryCodeInfo {
      activeTwoFaRecoveryCodes
      twoFaRecoveryCodesDownloadPath
    }
  }
}
    `;

/**
 * __useGetRecoveryCodesForUserQuery__
 *
 * To run a query within a React component, call `useGetRecoveryCodesForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecoveryCodesForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecoveryCodesForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetRecoveryCodesForUserQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetRecoveryCodesForUserQuery, GraphqlTypes.GetRecoveryCodesForUserQueryVariables> & ({ variables: GraphqlTypes.GetRecoveryCodesForUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetRecoveryCodesForUserQuery, GraphqlTypes.GetRecoveryCodesForUserQueryVariables>(GetRecoveryCodesForUserDocument, options);
      }
export function useGetRecoveryCodesForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetRecoveryCodesForUserQuery, GraphqlTypes.GetRecoveryCodesForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetRecoveryCodesForUserQuery, GraphqlTypes.GetRecoveryCodesForUserQueryVariables>(GetRecoveryCodesForUserDocument, options);
        }
// @ts-ignore
export function useGetRecoveryCodesForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecoveryCodesForUserQuery, GraphqlTypes.GetRecoveryCodesForUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRecoveryCodesForUserQuery, GraphqlTypes.GetRecoveryCodesForUserQueryVariables>;
export function useGetRecoveryCodesForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecoveryCodesForUserQuery, GraphqlTypes.GetRecoveryCodesForUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRecoveryCodesForUserQuery | undefined, GraphqlTypes.GetRecoveryCodesForUserQueryVariables>;
export function useGetRecoveryCodesForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecoveryCodesForUserQuery, GraphqlTypes.GetRecoveryCodesForUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetRecoveryCodesForUserQuery, GraphqlTypes.GetRecoveryCodesForUserQueryVariables>(GetRecoveryCodesForUserDocument, options);
        }
export type GetRecoveryCodesForUserQueryHookResult = ReturnType<typeof useGetRecoveryCodesForUserQuery>;
export type GetRecoveryCodesForUserLazyQueryHookResult = ReturnType<typeof useGetRecoveryCodesForUserLazyQuery>;
export type GetRecoveryCodesForUserSuspenseQueryHookResult = ReturnType<typeof useGetRecoveryCodesForUserSuspenseQuery>;
export type GetRecoveryCodesForUserQueryResult = Apollo.QueryResult<GraphqlTypes.GetRecoveryCodesForUserQuery, GraphqlTypes.GetRecoveryCodesForUserQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers($filters: UserFiltersCCTools, $includeDeleted: Boolean, $first: Int, $after: String) {
  usersCcTools(
    filters: $filters
    includeDeleted: $includeDeleted
    sort: [FIRST_NAME_ASC, LAST_NAME_ASC, EMAIL_ADDRESS_ASC]
    first: $first
    after: $after
  ) {
    count
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...UserFields
        linkedArenas {
          id
          name
        }
        roles {
          edges {
            node {
              ...RoleFields
            }
          }
        }
        groups {
          edges {
            node {
              ...GroupFields
            }
          }
        }
        arena {
          id
          name
        }
        contact {
          fullName
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${RoleFieldsFragmentDoc}
${GroupFieldsFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      includeDeleted: // value for 'includeDeleted'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetUsersQuery, GraphqlTypes.GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUsersQuery, GraphqlTypes.GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUsersQuery, GraphqlTypes.GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUsersQuery, GraphqlTypes.GetUsersQueryVariables>(GetUsersDocument, options);
        }
// @ts-ignore
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUsersQuery, GraphqlTypes.GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUsersQuery, GraphqlTypes.GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUsersQuery, GraphqlTypes.GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUsersQuery | undefined, GraphqlTypes.GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUsersQuery, GraphqlTypes.GetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUsersQuery, GraphqlTypes.GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GraphqlTypes.GetUsersQuery, GraphqlTypes.GetUsersQueryVariables>;
export const GetArenaNameDocument = gql`
    query GetArenaName($arenaId: ID!) {
  arena(id: $arenaId) {
    name
  }
}
    `;

/**
 * __useGetArenaNameQuery__
 *
 * To run a query within a React component, call `useGetArenaNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenaNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenaNameQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetArenaNameQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetArenaNameQuery, GraphqlTypes.GetArenaNameQueryVariables> & ({ variables: GraphqlTypes.GetArenaNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenaNameQuery, GraphqlTypes.GetArenaNameQueryVariables>(GetArenaNameDocument, options);
      }
export function useGetArenaNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenaNameQuery, GraphqlTypes.GetArenaNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenaNameQuery, GraphqlTypes.GetArenaNameQueryVariables>(GetArenaNameDocument, options);
        }
// @ts-ignore
export function useGetArenaNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaNameQuery, GraphqlTypes.GetArenaNameQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaNameQuery, GraphqlTypes.GetArenaNameQueryVariables>;
export function useGetArenaNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaNameQuery, GraphqlTypes.GetArenaNameQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaNameQuery | undefined, GraphqlTypes.GetArenaNameQueryVariables>;
export function useGetArenaNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaNameQuery, GraphqlTypes.GetArenaNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenaNameQuery, GraphqlTypes.GetArenaNameQueryVariables>(GetArenaNameDocument, options);
        }
export type GetArenaNameQueryHookResult = ReturnType<typeof useGetArenaNameQuery>;
export type GetArenaNameLazyQueryHookResult = ReturnType<typeof useGetArenaNameLazyQuery>;
export type GetArenaNameSuspenseQueryHookResult = ReturnType<typeof useGetArenaNameSuspenseQuery>;
export type GetArenaNameQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenaNameQuery, GraphqlTypes.GetArenaNameQueryVariables>;
export const GetRolesDocument = gql`
    query GetRoles {
  roles(sort: NAME_ASC) {
    edges {
      node {
        ...RoleFields
      }
    }
  }
}
    ${RoleFieldsFragmentDoc}`;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetRolesQuery, GraphqlTypes.GetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetRolesQuery, GraphqlTypes.GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetRolesQuery, GraphqlTypes.GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetRolesQuery, GraphqlTypes.GetRolesQueryVariables>(GetRolesDocument, options);
        }
// @ts-ignore
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRolesQuery, GraphqlTypes.GetRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRolesQuery, GraphqlTypes.GetRolesQueryVariables>;
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRolesQuery, GraphqlTypes.GetRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRolesQuery | undefined, GraphqlTypes.GetRolesQueryVariables>;
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRolesQuery, GraphqlTypes.GetRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetRolesQuery, GraphqlTypes.GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesSuspenseQueryHookResult = ReturnType<typeof useGetRolesSuspenseQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GraphqlTypes.GetRolesQuery, GraphqlTypes.GetRolesQueryVariables>;
export const GetGroupsLegacyDocument = gql`
    query GetGroupsLegacy($arenaId: ID!) {
  groups(arenaId: $arenaId, sort: TITLE_ASC) {
    edges {
      node {
        ...GroupFields
      }
    }
  }
}
    ${GroupFieldsFragmentDoc}`;

/**
 * __useGetGroupsLegacyQuery__
 *
 * To run a query within a React component, call `useGetGroupsLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsLegacyQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetGroupsLegacyQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetGroupsLegacyQuery, GraphqlTypes.GetGroupsLegacyQueryVariables> & ({ variables: GraphqlTypes.GetGroupsLegacyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGroupsLegacyQuery, GraphqlTypes.GetGroupsLegacyQueryVariables>(GetGroupsLegacyDocument, options);
      }
export function useGetGroupsLegacyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGroupsLegacyQuery, GraphqlTypes.GetGroupsLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGroupsLegacyQuery, GraphqlTypes.GetGroupsLegacyQueryVariables>(GetGroupsLegacyDocument, options);
        }
// @ts-ignore
export function useGetGroupsLegacySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGroupsLegacyQuery, GraphqlTypes.GetGroupsLegacyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGroupsLegacyQuery, GraphqlTypes.GetGroupsLegacyQueryVariables>;
export function useGetGroupsLegacySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGroupsLegacyQuery, GraphqlTypes.GetGroupsLegacyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGroupsLegacyQuery | undefined, GraphqlTypes.GetGroupsLegacyQueryVariables>;
export function useGetGroupsLegacySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGroupsLegacyQuery, GraphqlTypes.GetGroupsLegacyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGroupsLegacyQuery, GraphqlTypes.GetGroupsLegacyQueryVariables>(GetGroupsLegacyDocument, options);
        }
export type GetGroupsLegacyQueryHookResult = ReturnType<typeof useGetGroupsLegacyQuery>;
export type GetGroupsLegacyLazyQueryHookResult = ReturnType<typeof useGetGroupsLegacyLazyQuery>;
export type GetGroupsLegacySuspenseQueryHookResult = ReturnType<typeof useGetGroupsLegacySuspenseQuery>;
export type GetGroupsLegacyQueryResult = Apollo.QueryResult<GraphqlTypes.GetGroupsLegacyQuery, GraphqlTypes.GetGroupsLegacyQueryVariables>;
export const CurrentUserQueryDocument = gql`
    query CurrentUserQuery {
  currentUser {
    roles {
      edges {
        node {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useCurrentUserQueryQuery__
 *
 * To run a query within a React component, call `useCurrentUserQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQueryQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.CurrentUserQueryQuery, GraphqlTypes.CurrentUserQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.CurrentUserQueryQuery, GraphqlTypes.CurrentUserQueryQueryVariables>(CurrentUserQueryDocument, options);
      }
export function useCurrentUserQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.CurrentUserQueryQuery, GraphqlTypes.CurrentUserQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.CurrentUserQueryQuery, GraphqlTypes.CurrentUserQueryQueryVariables>(CurrentUserQueryDocument, options);
        }
// @ts-ignore
export function useCurrentUserQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrentUserQueryQuery, GraphqlTypes.CurrentUserQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CurrentUserQueryQuery, GraphqlTypes.CurrentUserQueryQueryVariables>;
export function useCurrentUserQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrentUserQueryQuery, GraphqlTypes.CurrentUserQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CurrentUserQueryQuery | undefined, GraphqlTypes.CurrentUserQueryQueryVariables>;
export function useCurrentUserQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrentUserQueryQuery, GraphqlTypes.CurrentUserQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.CurrentUserQueryQuery, GraphqlTypes.CurrentUserQueryQueryVariables>(CurrentUserQueryDocument, options);
        }
export type CurrentUserQueryQueryHookResult = ReturnType<typeof useCurrentUserQueryQuery>;
export type CurrentUserQueryLazyQueryHookResult = ReturnType<typeof useCurrentUserQueryLazyQuery>;
export type CurrentUserQuerySuspenseQueryHookResult = ReturnType<typeof useCurrentUserQuerySuspenseQuery>;
export type CurrentUserQueryQueryResult = Apollo.QueryResult<GraphqlTypes.CurrentUserQueryQuery, GraphqlTypes.CurrentUserQueryQueryVariables>;
export const GetNestedOwnershipFeatureFlagDocument = gql`
    query GetNestedOwnershipFeatureFlag {
  devFeatures {
    showComplianceCanopyNestedOwnership
  }
}
    `;

/**
 * __useGetNestedOwnershipFeatureFlagQuery__
 *
 * To run a query within a React component, call `useGetNestedOwnershipFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNestedOwnershipFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNestedOwnershipFeatureFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNestedOwnershipFeatureFlagQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetNestedOwnershipFeatureFlagQuery, GraphqlTypes.GetNestedOwnershipFeatureFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetNestedOwnershipFeatureFlagQuery, GraphqlTypes.GetNestedOwnershipFeatureFlagQueryVariables>(GetNestedOwnershipFeatureFlagDocument, options);
      }
export function useGetNestedOwnershipFeatureFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetNestedOwnershipFeatureFlagQuery, GraphqlTypes.GetNestedOwnershipFeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetNestedOwnershipFeatureFlagQuery, GraphqlTypes.GetNestedOwnershipFeatureFlagQueryVariables>(GetNestedOwnershipFeatureFlagDocument, options);
        }
// @ts-ignore
export function useGetNestedOwnershipFeatureFlagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNestedOwnershipFeatureFlagQuery, GraphqlTypes.GetNestedOwnershipFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNestedOwnershipFeatureFlagQuery, GraphqlTypes.GetNestedOwnershipFeatureFlagQueryVariables>;
export function useGetNestedOwnershipFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNestedOwnershipFeatureFlagQuery, GraphqlTypes.GetNestedOwnershipFeatureFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNestedOwnershipFeatureFlagQuery | undefined, GraphqlTypes.GetNestedOwnershipFeatureFlagQueryVariables>;
export function useGetNestedOwnershipFeatureFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNestedOwnershipFeatureFlagQuery, GraphqlTypes.GetNestedOwnershipFeatureFlagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetNestedOwnershipFeatureFlagQuery, GraphqlTypes.GetNestedOwnershipFeatureFlagQueryVariables>(GetNestedOwnershipFeatureFlagDocument, options);
        }
export type GetNestedOwnershipFeatureFlagQueryHookResult = ReturnType<typeof useGetNestedOwnershipFeatureFlagQuery>;
export type GetNestedOwnershipFeatureFlagLazyQueryHookResult = ReturnType<typeof useGetNestedOwnershipFeatureFlagLazyQuery>;
export type GetNestedOwnershipFeatureFlagSuspenseQueryHookResult = ReturnType<typeof useGetNestedOwnershipFeatureFlagSuspenseQuery>;
export type GetNestedOwnershipFeatureFlagQueryResult = Apollo.QueryResult<GraphqlTypes.GetNestedOwnershipFeatureFlagQuery, GraphqlTypes.GetNestedOwnershipFeatureFlagQueryVariables>;
export const GetClientNameByIdDocument = gql`
    query GetClientNameById($arenaIds: [ID!]) {
  arenas(arenaIds: $arenaIds, includeAdminArena: false) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetClientNameByIdQuery__
 *
 * To run a query within a React component, call `useGetClientNameByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientNameByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientNameByIdQuery({
 *   variables: {
 *      arenaIds: // value for 'arenaIds'
 *   },
 * });
 */
export function useGetClientNameByIdQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetClientNameByIdQuery, GraphqlTypes.GetClientNameByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetClientNameByIdQuery, GraphqlTypes.GetClientNameByIdQueryVariables>(GetClientNameByIdDocument, options);
      }
export function useGetClientNameByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetClientNameByIdQuery, GraphqlTypes.GetClientNameByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetClientNameByIdQuery, GraphqlTypes.GetClientNameByIdQueryVariables>(GetClientNameByIdDocument, options);
        }
// @ts-ignore
export function useGetClientNameByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientNameByIdQuery, GraphqlTypes.GetClientNameByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetClientNameByIdQuery, GraphqlTypes.GetClientNameByIdQueryVariables>;
export function useGetClientNameByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientNameByIdQuery, GraphqlTypes.GetClientNameByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetClientNameByIdQuery | undefined, GraphqlTypes.GetClientNameByIdQueryVariables>;
export function useGetClientNameByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientNameByIdQuery, GraphqlTypes.GetClientNameByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetClientNameByIdQuery, GraphqlTypes.GetClientNameByIdQueryVariables>(GetClientNameByIdDocument, options);
        }
export type GetClientNameByIdQueryHookResult = ReturnType<typeof useGetClientNameByIdQuery>;
export type GetClientNameByIdLazyQueryHookResult = ReturnType<typeof useGetClientNameByIdLazyQuery>;
export type GetClientNameByIdSuspenseQueryHookResult = ReturnType<typeof useGetClientNameByIdSuspenseQuery>;
export type GetClientNameByIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetClientNameByIdQuery, GraphqlTypes.GetClientNameByIdQueryVariables>;
export const GetArenasWithSearchDocument = gql`
    query GetArenasWithSearch($includeAdminArena: Boolean, $searchTerm: String!) {
  arenas(includeAdminArena: $includeAdminArena, searchTerm: $searchTerm) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetArenasWithSearchQuery__
 *
 * To run a query within a React component, call `useGetArenasWithSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenasWithSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenasWithSearchQuery({
 *   variables: {
 *      includeAdminArena: // value for 'includeAdminArena'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetArenasWithSearchQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetArenasWithSearchQuery, GraphqlTypes.GetArenasWithSearchQueryVariables> & ({ variables: GraphqlTypes.GetArenasWithSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenasWithSearchQuery, GraphqlTypes.GetArenasWithSearchQueryVariables>(GetArenasWithSearchDocument, options);
      }
export function useGetArenasWithSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenasWithSearchQuery, GraphqlTypes.GetArenasWithSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenasWithSearchQuery, GraphqlTypes.GetArenasWithSearchQueryVariables>(GetArenasWithSearchDocument, options);
        }
// @ts-ignore
export function useGetArenasWithSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasWithSearchQuery, GraphqlTypes.GetArenasWithSearchQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenasWithSearchQuery, GraphqlTypes.GetArenasWithSearchQueryVariables>;
export function useGetArenasWithSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasWithSearchQuery, GraphqlTypes.GetArenasWithSearchQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenasWithSearchQuery | undefined, GraphqlTypes.GetArenasWithSearchQueryVariables>;
export function useGetArenasWithSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasWithSearchQuery, GraphqlTypes.GetArenasWithSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenasWithSearchQuery, GraphqlTypes.GetArenasWithSearchQueryVariables>(GetArenasWithSearchDocument, options);
        }
export type GetArenasWithSearchQueryHookResult = ReturnType<typeof useGetArenasWithSearchQuery>;
export type GetArenasWithSearchLazyQueryHookResult = ReturnType<typeof useGetArenasWithSearchLazyQuery>;
export type GetArenasWithSearchSuspenseQueryHookResult = ReturnType<typeof useGetArenasWithSearchSuspenseQuery>;
export type GetArenasWithSearchQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenasWithSearchQuery, GraphqlTypes.GetArenasWithSearchQueryVariables>;
export const GetEntitiesWithSearchDocument = gql`
    query GetEntitiesWithSearch($arenaId: ID, $searchTerm: String, $filterEntitiesWithTransactions: Boolean) {
  investmentEntitiesByArena(
    arenaId: $arenaId
    searchTerm: $searchTerm
    filterEntitiesWithTransactions: $filterEntitiesWithTransactions
  ) {
    edges {
      node {
        id
        name
        complianceSettings {
          complianceProgram
          enabled
        }
      }
    }
  }
}
    `;

/**
 * __useGetEntitiesWithSearchQuery__
 *
 * To run a query within a React component, call `useGetEntitiesWithSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitiesWithSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitiesWithSearchQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      searchTerm: // value for 'searchTerm'
 *      filterEntitiesWithTransactions: // value for 'filterEntitiesWithTransactions'
 *   },
 * });
 */
export function useGetEntitiesWithSearchQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEntitiesWithSearchQuery, GraphqlTypes.GetEntitiesWithSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntitiesWithSearchQuery, GraphqlTypes.GetEntitiesWithSearchQueryVariables>(GetEntitiesWithSearchDocument, options);
      }
export function useGetEntitiesWithSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntitiesWithSearchQuery, GraphqlTypes.GetEntitiesWithSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntitiesWithSearchQuery, GraphqlTypes.GetEntitiesWithSearchQueryVariables>(GetEntitiesWithSearchDocument, options);
        }
// @ts-ignore
export function useGetEntitiesWithSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesWithSearchQuery, GraphqlTypes.GetEntitiesWithSearchQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesWithSearchQuery, GraphqlTypes.GetEntitiesWithSearchQueryVariables>;
export function useGetEntitiesWithSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesWithSearchQuery, GraphqlTypes.GetEntitiesWithSearchQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesWithSearchQuery | undefined, GraphqlTypes.GetEntitiesWithSearchQueryVariables>;
export function useGetEntitiesWithSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesWithSearchQuery, GraphqlTypes.GetEntitiesWithSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntitiesWithSearchQuery, GraphqlTypes.GetEntitiesWithSearchQueryVariables>(GetEntitiesWithSearchDocument, options);
        }
export type GetEntitiesWithSearchQueryHookResult = ReturnType<typeof useGetEntitiesWithSearchQuery>;
export type GetEntitiesWithSearchLazyQueryHookResult = ReturnType<typeof useGetEntitiesWithSearchLazyQuery>;
export type GetEntitiesWithSearchSuspenseQueryHookResult = ReturnType<typeof useGetEntitiesWithSearchSuspenseQuery>;
export type GetEntitiesWithSearchQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntitiesWithSearchQuery, GraphqlTypes.GetEntitiesWithSearchQueryVariables>;
export const GetAllCurrenciesDocument = gql`
    query GetAllCurrencies {
  currencies {
    id
    code
    fullName
    symbol
    flagUnicode
  }
}
    `;

/**
 * __useGetAllCurrenciesQuery__
 *
 * To run a query within a React component, call `useGetAllCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAllCurrenciesQuery, GraphqlTypes.GetAllCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAllCurrenciesQuery, GraphqlTypes.GetAllCurrenciesQueryVariables>(GetAllCurrenciesDocument, options);
      }
export function useGetAllCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAllCurrenciesQuery, GraphqlTypes.GetAllCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAllCurrenciesQuery, GraphqlTypes.GetAllCurrenciesQueryVariables>(GetAllCurrenciesDocument, options);
        }
// @ts-ignore
export function useGetAllCurrenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllCurrenciesQuery, GraphqlTypes.GetAllCurrenciesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllCurrenciesQuery, GraphqlTypes.GetAllCurrenciesQueryVariables>;
export function useGetAllCurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllCurrenciesQuery, GraphqlTypes.GetAllCurrenciesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllCurrenciesQuery | undefined, GraphqlTypes.GetAllCurrenciesQueryVariables>;
export function useGetAllCurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllCurrenciesQuery, GraphqlTypes.GetAllCurrenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAllCurrenciesQuery, GraphqlTypes.GetAllCurrenciesQueryVariables>(GetAllCurrenciesDocument, options);
        }
export type GetAllCurrenciesQueryHookResult = ReturnType<typeof useGetAllCurrenciesQuery>;
export type GetAllCurrenciesLazyQueryHookResult = ReturnType<typeof useGetAllCurrenciesLazyQuery>;
export type GetAllCurrenciesSuspenseQueryHookResult = ReturnType<typeof useGetAllCurrenciesSuspenseQuery>;
export type GetAllCurrenciesQueryResult = Apollo.QueryResult<GraphqlTypes.GetAllCurrenciesQuery, GraphqlTypes.GetAllCurrenciesQueryVariables>;
export const GetArenaDocument = gql`
    query GetArena($id: ID!) {
  arena(id: $id) {
    name
    id
    domain
    secondLevelDomain
    hasApiUser
  }
}
    `;

/**
 * __useGetArenaQuery__
 *
 * To run a query within a React component, call `useGetArenaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetArenaQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetArenaQuery, GraphqlTypes.GetArenaQueryVariables> & ({ variables: GraphqlTypes.GetArenaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenaQuery, GraphqlTypes.GetArenaQueryVariables>(GetArenaDocument, options);
      }
export function useGetArenaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenaQuery, GraphqlTypes.GetArenaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenaQuery, GraphqlTypes.GetArenaQueryVariables>(GetArenaDocument, options);
        }
// @ts-ignore
export function useGetArenaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaQuery, GraphqlTypes.GetArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaQuery, GraphqlTypes.GetArenaQueryVariables>;
export function useGetArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaQuery, GraphqlTypes.GetArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaQuery | undefined, GraphqlTypes.GetArenaQueryVariables>;
export function useGetArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaQuery, GraphqlTypes.GetArenaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenaQuery, GraphqlTypes.GetArenaQueryVariables>(GetArenaDocument, options);
        }
export type GetArenaQueryHookResult = ReturnType<typeof useGetArenaQuery>;
export type GetArenaLazyQueryHookResult = ReturnType<typeof useGetArenaLazyQuery>;
export type GetArenaSuspenseQueryHookResult = ReturnType<typeof useGetArenaSuspenseQuery>;
export type GetArenaQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenaQuery, GraphqlTypes.GetArenaQueryVariables>;
export const GetArenasDocument = gql`
    query GetArenas($includeAdminArena: Boolean!, $applicationContext: ApplicationContext!) {
  arenas(
    includeAdminArena: $includeAdminArena
    applicationContext: $applicationContext
  ) {
    edges {
      node {
        id
        domain
        name
        logoUrl
      }
    }
  }
}
    `;

/**
 * __useGetArenasQuery__
 *
 * To run a query within a React component, call `useGetArenasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenasQuery({
 *   variables: {
 *      includeAdminArena: // value for 'includeAdminArena'
 *      applicationContext: // value for 'applicationContext'
 *   },
 * });
 */
export function useGetArenasQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables> & ({ variables: GraphqlTypes.GetArenasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>(GetArenasDocument, options);
      }
export function useGetArenasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>(GetArenasDocument, options);
        }
// @ts-ignore
export function useGetArenasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>;
export function useGetArenasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenasQuery | undefined, GraphqlTypes.GetArenasQueryVariables>;
export function useGetArenasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>(GetArenasDocument, options);
        }
export type GetArenasQueryHookResult = ReturnType<typeof useGetArenasQuery>;
export type GetArenasLazyQueryHookResult = ReturnType<typeof useGetArenasLazyQuery>;
export type GetArenasSuspenseQueryHookResult = ReturnType<typeof useGetArenasSuspenseQuery>;
export type GetArenasQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>;
export const GetEntitiesDocument = gql`
    query GetEntities {
  investmentEntities(filters: {isFundAdminEntities: true}) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetEntitiesQuery__
 *
 * To run a query within a React component, call `useGetEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEntitiesQuery, GraphqlTypes.GetEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntitiesQuery, GraphqlTypes.GetEntitiesQueryVariables>(GetEntitiesDocument, options);
      }
export function useGetEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntitiesQuery, GraphqlTypes.GetEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntitiesQuery, GraphqlTypes.GetEntitiesQueryVariables>(GetEntitiesDocument, options);
        }
// @ts-ignore
export function useGetEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesQuery, GraphqlTypes.GetEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesQuery, GraphqlTypes.GetEntitiesQueryVariables>;
export function useGetEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesQuery, GraphqlTypes.GetEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesQuery | undefined, GraphqlTypes.GetEntitiesQueryVariables>;
export function useGetEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesQuery, GraphqlTypes.GetEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntitiesQuery, GraphqlTypes.GetEntitiesQueryVariables>(GetEntitiesDocument, options);
        }
export type GetEntitiesQueryHookResult = ReturnType<typeof useGetEntitiesQuery>;
export type GetEntitiesLazyQueryHookResult = ReturnType<typeof useGetEntitiesLazyQuery>;
export type GetEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetEntitiesSuspenseQuery>;
export type GetEntitiesQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntitiesQuery, GraphqlTypes.GetEntitiesQueryVariables>;
export const CreateWorkbookDocument = gql`
    mutation CreateWorkbook($entityId: Int!, $dateRangeInput: DateRangeInput!, $workbookConfigsInput: WorkbookConfigsInput!) {
  createWorkbook(
    entityId: $entityId
    dateRange: $dateRangeInput
    configs: $workbookConfigsInput
  ) {
    id
    status
  }
}
    `;
export type CreateWorkbookMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateWorkbookMutation, GraphqlTypes.CreateWorkbookMutationVariables>;

/**
 * __useCreateWorkbookMutation__
 *
 * To run a mutation, you first call `useCreateWorkbookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkbookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkbookMutation, { data, loading, error }] = useCreateWorkbookMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      dateRangeInput: // value for 'dateRangeInput'
 *      workbookConfigsInput: // value for 'workbookConfigsInput'
 *   },
 * });
 */
export function useCreateWorkbookMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateWorkbookMutation, GraphqlTypes.CreateWorkbookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateWorkbookMutation, GraphqlTypes.CreateWorkbookMutationVariables>(CreateWorkbookDocument, options);
      }
export type CreateWorkbookMutationHookResult = ReturnType<typeof useCreateWorkbookMutation>;
export type CreateWorkbookMutationResult = Apollo.MutationResult<GraphqlTypes.CreateWorkbookMutation>;
export type CreateWorkbookMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateWorkbookMutation, GraphqlTypes.CreateWorkbookMutationVariables>;
export const BackgroundTaskDocument = gql`
    query BackgroundTask($taskId: Int!) {
  backgroundTask(taskId: $taskId) {
    id
    name
    status
    files {
      id
      content {
        downloadUrl
      }
    }
  }
}
    `;

/**
 * __useBackgroundTaskQuery__
 *
 * To run a query within a React component, call `useBackgroundTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackgroundTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackgroundTaskQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useBackgroundTaskQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.BackgroundTaskQuery, GraphqlTypes.BackgroundTaskQueryVariables> & ({ variables: GraphqlTypes.BackgroundTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.BackgroundTaskQuery, GraphqlTypes.BackgroundTaskQueryVariables>(BackgroundTaskDocument, options);
      }
export function useBackgroundTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.BackgroundTaskQuery, GraphqlTypes.BackgroundTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.BackgroundTaskQuery, GraphqlTypes.BackgroundTaskQueryVariables>(BackgroundTaskDocument, options);
        }
// @ts-ignore
export function useBackgroundTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.BackgroundTaskQuery, GraphqlTypes.BackgroundTaskQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.BackgroundTaskQuery, GraphqlTypes.BackgroundTaskQueryVariables>;
export function useBackgroundTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.BackgroundTaskQuery, GraphqlTypes.BackgroundTaskQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.BackgroundTaskQuery | undefined, GraphqlTypes.BackgroundTaskQueryVariables>;
export function useBackgroundTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.BackgroundTaskQuery, GraphqlTypes.BackgroundTaskQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.BackgroundTaskQuery, GraphqlTypes.BackgroundTaskQueryVariables>(BackgroundTaskDocument, options);
        }
export type BackgroundTaskQueryHookResult = ReturnType<typeof useBackgroundTaskQuery>;
export type BackgroundTaskLazyQueryHookResult = ReturnType<typeof useBackgroundTaskLazyQuery>;
export type BackgroundTaskSuspenseQueryHookResult = ReturnType<typeof useBackgroundTaskSuspenseQuery>;
export type BackgroundTaskQueryResult = Apollo.QueryResult<GraphqlTypes.BackgroundTaskQuery, GraphqlTypes.BackgroundTaskQueryVariables>;
export const GetEntityWithTransactionCountsDocument = gql`
    query GetEntityWithTransactionCounts($entityId: ID!, $startDate: Date, $withCapitalCall: Boolean!, $withRedemption: Boolean!, $withDistribution: Boolean!, $withNetIncome: Boolean!) {
  investmentEntity(id: $entityId) {
    owningPositions {
      edges {
        node {
          capitalCalls(startDate: $startDate) @include(if: $withCapitalCall) {
            count
          }
          distributions(startDate: $startDate) @include(if: $withDistribution) {
            count
          }
          redemptions(startDate: $startDate) @include(if: $withRedemption) {
            count
          }
          netIncomes(startDate: $startDate) @include(if: $withNetIncome) {
            count
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEntityWithTransactionCountsQuery__
 *
 * To run a query within a React component, call `useGetEntityWithTransactionCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityWithTransactionCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityWithTransactionCountsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      startDate: // value for 'startDate'
 *      withCapitalCall: // value for 'withCapitalCall'
 *      withRedemption: // value for 'withRedemption'
 *      withDistribution: // value for 'withDistribution'
 *      withNetIncome: // value for 'withNetIncome'
 *   },
 * });
 */
export function useGetEntityWithTransactionCountsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityWithTransactionCountsQuery, GraphqlTypes.GetEntityWithTransactionCountsQueryVariables> & ({ variables: GraphqlTypes.GetEntityWithTransactionCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityWithTransactionCountsQuery, GraphqlTypes.GetEntityWithTransactionCountsQueryVariables>(GetEntityWithTransactionCountsDocument, options);
      }
export function useGetEntityWithTransactionCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityWithTransactionCountsQuery, GraphqlTypes.GetEntityWithTransactionCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityWithTransactionCountsQuery, GraphqlTypes.GetEntityWithTransactionCountsQueryVariables>(GetEntityWithTransactionCountsDocument, options);
        }
// @ts-ignore
export function useGetEntityWithTransactionCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityWithTransactionCountsQuery, GraphqlTypes.GetEntityWithTransactionCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityWithTransactionCountsQuery, GraphqlTypes.GetEntityWithTransactionCountsQueryVariables>;
export function useGetEntityWithTransactionCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityWithTransactionCountsQuery, GraphqlTypes.GetEntityWithTransactionCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityWithTransactionCountsQuery | undefined, GraphqlTypes.GetEntityWithTransactionCountsQueryVariables>;
export function useGetEntityWithTransactionCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityWithTransactionCountsQuery, GraphqlTypes.GetEntityWithTransactionCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityWithTransactionCountsQuery, GraphqlTypes.GetEntityWithTransactionCountsQueryVariables>(GetEntityWithTransactionCountsDocument, options);
        }
export type GetEntityWithTransactionCountsQueryHookResult = ReturnType<typeof useGetEntityWithTransactionCountsQuery>;
export type GetEntityWithTransactionCountsLazyQueryHookResult = ReturnType<typeof useGetEntityWithTransactionCountsLazyQuery>;
export type GetEntityWithTransactionCountsSuspenseQueryHookResult = ReturnType<typeof useGetEntityWithTransactionCountsSuspenseQuery>;
export type GetEntityWithTransactionCountsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityWithTransactionCountsQuery, GraphqlTypes.GetEntityWithTransactionCountsQueryVariables>;
export const GetEntityDeltasDocument = gql`
    query GetEntityDeltas($entitiesFilters: EntitiesFilters, $transferOnly: Boolean) {
  investmentEntities(filters: $entitiesFilters) {
    edges {
      node {
        deltas(transferOnly: $transferOnly) {
          date
          fromPositionId
          toPositionId
        }
      }
    }
  }
}
    `;

/**
 * __useGetEntityDeltasQuery__
 *
 * To run a query within a React component, call `useGetEntityDeltasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityDeltasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityDeltasQuery({
 *   variables: {
 *      entitiesFilters: // value for 'entitiesFilters'
 *      transferOnly: // value for 'transferOnly'
 *   },
 * });
 */
export function useGetEntityDeltasQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEntityDeltasQuery, GraphqlTypes.GetEntityDeltasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityDeltasQuery, GraphqlTypes.GetEntityDeltasQueryVariables>(GetEntityDeltasDocument, options);
      }
export function useGetEntityDeltasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityDeltasQuery, GraphqlTypes.GetEntityDeltasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityDeltasQuery, GraphqlTypes.GetEntityDeltasQueryVariables>(GetEntityDeltasDocument, options);
        }
// @ts-ignore
export function useGetEntityDeltasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityDeltasQuery, GraphqlTypes.GetEntityDeltasQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityDeltasQuery, GraphqlTypes.GetEntityDeltasQueryVariables>;
export function useGetEntityDeltasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityDeltasQuery, GraphqlTypes.GetEntityDeltasQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityDeltasQuery | undefined, GraphqlTypes.GetEntityDeltasQueryVariables>;
export function useGetEntityDeltasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityDeltasQuery, GraphqlTypes.GetEntityDeltasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityDeltasQuery, GraphqlTypes.GetEntityDeltasQueryVariables>(GetEntityDeltasDocument, options);
        }
export type GetEntityDeltasQueryHookResult = ReturnType<typeof useGetEntityDeltasQuery>;
export type GetEntityDeltasLazyQueryHookResult = ReturnType<typeof useGetEntityDeltasLazyQuery>;
export type GetEntityDeltasSuspenseQueryHookResult = ReturnType<typeof useGetEntityDeltasSuspenseQuery>;
export type GetEntityDeltasQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityDeltasQuery, GraphqlTypes.GetEntityDeltasQueryVariables>;
export const GetEntityTransferSettingsDocument = gql`
    query GetEntityTransferSettings($entityId: ID!) {
  investmentEntity(id: $entityId) {
    transferAccountingEnabled
  }
}
    `;

/**
 * __useGetEntityTransferSettingsQuery__
 *
 * To run a query within a React component, call `useGetEntityTransferSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityTransferSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityTransferSettingsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEntityTransferSettingsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityTransferSettingsQuery, GraphqlTypes.GetEntityTransferSettingsQueryVariables> & ({ variables: GraphqlTypes.GetEntityTransferSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityTransferSettingsQuery, GraphqlTypes.GetEntityTransferSettingsQueryVariables>(GetEntityTransferSettingsDocument, options);
      }
export function useGetEntityTransferSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityTransferSettingsQuery, GraphqlTypes.GetEntityTransferSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityTransferSettingsQuery, GraphqlTypes.GetEntityTransferSettingsQueryVariables>(GetEntityTransferSettingsDocument, options);
        }
// @ts-ignore
export function useGetEntityTransferSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityTransferSettingsQuery, GraphqlTypes.GetEntityTransferSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityTransferSettingsQuery, GraphqlTypes.GetEntityTransferSettingsQueryVariables>;
export function useGetEntityTransferSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityTransferSettingsQuery, GraphqlTypes.GetEntityTransferSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityTransferSettingsQuery | undefined, GraphqlTypes.GetEntityTransferSettingsQueryVariables>;
export function useGetEntityTransferSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityTransferSettingsQuery, GraphqlTypes.GetEntityTransferSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityTransferSettingsQuery, GraphqlTypes.GetEntityTransferSettingsQueryVariables>(GetEntityTransferSettingsDocument, options);
        }
export type GetEntityTransferSettingsQueryHookResult = ReturnType<typeof useGetEntityTransferSettingsQuery>;
export type GetEntityTransferSettingsLazyQueryHookResult = ReturnType<typeof useGetEntityTransferSettingsLazyQuery>;
export type GetEntityTransferSettingsSuspenseQueryHookResult = ReturnType<typeof useGetEntityTransferSettingsSuspenseQuery>;
export type GetEntityTransferSettingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityTransferSettingsQuery, GraphqlTypes.GetEntityTransferSettingsQueryVariables>;
export const GetEntityMixFundStatusDocument = gql`
    query GetEntityMixFundStatus($entityId: ID!, $startDate: Date, $endDate: Date) {
  investmentEntity(id: $entityId) {
    id
    hasMixedCallsAndStandaloneContributions(
      startDate: $startDate
      endDate: $endDate
    )
  }
}
    `;

/**
 * __useGetEntityMixFundStatusQuery__
 *
 * To run a query within a React component, call `useGetEntityMixFundStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityMixFundStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityMixFundStatusQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetEntityMixFundStatusQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityMixFundStatusQuery, GraphqlTypes.GetEntityMixFundStatusQueryVariables> & ({ variables: GraphqlTypes.GetEntityMixFundStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityMixFundStatusQuery, GraphqlTypes.GetEntityMixFundStatusQueryVariables>(GetEntityMixFundStatusDocument, options);
      }
export function useGetEntityMixFundStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityMixFundStatusQuery, GraphqlTypes.GetEntityMixFundStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityMixFundStatusQuery, GraphqlTypes.GetEntityMixFundStatusQueryVariables>(GetEntityMixFundStatusDocument, options);
        }
// @ts-ignore
export function useGetEntityMixFundStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityMixFundStatusQuery, GraphqlTypes.GetEntityMixFundStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityMixFundStatusQuery, GraphqlTypes.GetEntityMixFundStatusQueryVariables>;
export function useGetEntityMixFundStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityMixFundStatusQuery, GraphqlTypes.GetEntityMixFundStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityMixFundStatusQuery | undefined, GraphqlTypes.GetEntityMixFundStatusQueryVariables>;
export function useGetEntityMixFundStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityMixFundStatusQuery, GraphqlTypes.GetEntityMixFundStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityMixFundStatusQuery, GraphqlTypes.GetEntityMixFundStatusQueryVariables>(GetEntityMixFundStatusDocument, options);
        }
export type GetEntityMixFundStatusQueryHookResult = ReturnType<typeof useGetEntityMixFundStatusQuery>;
export type GetEntityMixFundStatusLazyQueryHookResult = ReturnType<typeof useGetEntityMixFundStatusLazyQuery>;
export type GetEntityMixFundStatusSuspenseQueryHookResult = ReturnType<typeof useGetEntityMixFundStatusSuspenseQuery>;
export type GetEntityMixFundStatusQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityMixFundStatusQuery, GraphqlTypes.GetEntityMixFundStatusQueryVariables>;
export const UserLoginDocument = gql`
    mutation UserLogin($loginInput: LoginInput!) {
  login(objectInput: $loginInput) {
    ... on LoginObject {
      user {
        id
        firstName
        lastName
        fullName
        ...UserAccessFields
      }
      csrfToken
    }
    ... on LoginVerificationRequiredResponse {
      message
      twoFaType
      twoFaSmsLastFourDigits
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    ${UserAccessFieldsFragmentDoc}`;
export type UserLoginMutationFn = Apollo.MutationFunction<GraphqlTypes.UserLoginMutation, GraphqlTypes.UserLoginMutationVariables>;

/**
 * __useUserLoginMutation__
 *
 * To run a mutation, you first call `useUserLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userLoginMutation, { data, loading, error }] = useUserLoginMutation({
 *   variables: {
 *      loginInput: // value for 'loginInput'
 *   },
 * });
 */
export function useUserLoginMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UserLoginMutation, GraphqlTypes.UserLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UserLoginMutation, GraphqlTypes.UserLoginMutationVariables>(UserLoginDocument, options);
      }
export type UserLoginMutationHookResult = ReturnType<typeof useUserLoginMutation>;
export type UserLoginMutationResult = Apollo.MutationResult<GraphqlTypes.UserLoginMutation>;
export type UserLoginMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UserLoginMutation, GraphqlTypes.UserLoginMutationVariables>;
export const GetSsoStatusForAdminDocument = gql`
    query GetSsoStatusForAdmin {
  unauthenticatedSsoconfig {
    providerType
    name
    status
  }
}
    `;

/**
 * __useGetSsoStatusForAdminQuery__
 *
 * To run a query within a React component, call `useGetSsoStatusForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSsoStatusForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSsoStatusForAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSsoStatusForAdminQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetSsoStatusForAdminQuery, GraphqlTypes.GetSsoStatusForAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSsoStatusForAdminQuery, GraphqlTypes.GetSsoStatusForAdminQueryVariables>(GetSsoStatusForAdminDocument, options);
      }
export function useGetSsoStatusForAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSsoStatusForAdminQuery, GraphqlTypes.GetSsoStatusForAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSsoStatusForAdminQuery, GraphqlTypes.GetSsoStatusForAdminQueryVariables>(GetSsoStatusForAdminDocument, options);
        }
// @ts-ignore
export function useGetSsoStatusForAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSsoStatusForAdminQuery, GraphqlTypes.GetSsoStatusForAdminQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSsoStatusForAdminQuery, GraphqlTypes.GetSsoStatusForAdminQueryVariables>;
export function useGetSsoStatusForAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSsoStatusForAdminQuery, GraphqlTypes.GetSsoStatusForAdminQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSsoStatusForAdminQuery | undefined, GraphqlTypes.GetSsoStatusForAdminQueryVariables>;
export function useGetSsoStatusForAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSsoStatusForAdminQuery, GraphqlTypes.GetSsoStatusForAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSsoStatusForAdminQuery, GraphqlTypes.GetSsoStatusForAdminQueryVariables>(GetSsoStatusForAdminDocument, options);
        }
export type GetSsoStatusForAdminQueryHookResult = ReturnType<typeof useGetSsoStatusForAdminQuery>;
export type GetSsoStatusForAdminLazyQueryHookResult = ReturnType<typeof useGetSsoStatusForAdminLazyQuery>;
export type GetSsoStatusForAdminSuspenseQueryHookResult = ReturnType<typeof useGetSsoStatusForAdminSuspenseQuery>;
export type GetSsoStatusForAdminQueryResult = Apollo.QueryResult<GraphqlTypes.GetSsoStatusForAdminQuery, GraphqlTypes.GetSsoStatusForAdminQueryVariables>;
export const GetFundAdminServicesDocument = gql`
    query GetFundAdminServices($serviceIds: [String!]) {
  canopyFundAdminServices(serviceIds: $serviceIds) {
    edges {
      node {
        id
        externalTicketIdentifier
        details
        status
        isPublished
        createdAt
        modifiedAt
        requestType
        documents {
          id
          documentVersionId
          documentVersion {
            name
            id
            directDownloadUrl
          }
          documentType
        }
        objects {
          objectValue {
            ... on UserObjectType {
              id
              fullName
              emailAddress
            }
            ... on AccountObjectType {
              id
              name
            }
            ... on EntityCollectionObjectType {
              id
              name
              entitiesFromCanopy {
                count
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
          objectDetails
        }
      }
    }
  }
}
    `;

/**
 * __useGetFundAdminServicesQuery__
 *
 * To run a query within a React component, call `useGetFundAdminServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundAdminServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundAdminServicesQuery({
 *   variables: {
 *      serviceIds: // value for 'serviceIds'
 *   },
 * });
 */
export function useGetFundAdminServicesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>(GetFundAdminServicesDocument, options);
      }
export function useGetFundAdminServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>(GetFundAdminServicesDocument, options);
        }
// @ts-ignore
export function useGetFundAdminServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>;
export function useGetFundAdminServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFundAdminServicesQuery | undefined, GraphqlTypes.GetFundAdminServicesQueryVariables>;
export function useGetFundAdminServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>(GetFundAdminServicesDocument, options);
        }
export type GetFundAdminServicesQueryHookResult = ReturnType<typeof useGetFundAdminServicesQuery>;
export type GetFundAdminServicesLazyQueryHookResult = ReturnType<typeof useGetFundAdminServicesLazyQuery>;
export type GetFundAdminServicesSuspenseQueryHookResult = ReturnType<typeof useGetFundAdminServicesSuspenseQuery>;
export type GetFundAdminServicesQueryResult = Apollo.QueryResult<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>;
export const UploadFundDocsDocument = gql`
    mutation uploadFundDocs($fundAdminServiceId: Int!, $s3ObjectKeys: [S3DocumentInput]!, $documentsType: FundAdminServiceDocumentType!) {
  fundAdminServiceRequestOps {
    uploadDocumentsCanopy(
      fundAdminServiceId: $fundAdminServiceId
      s3ObjectKeys: $s3ObjectKeys
      documentsType: $documentsType
    ) {
      fundAdminServiceDocuments {
        id
      }
    }
  }
}
    `;
export type UploadFundDocsMutationFn = Apollo.MutationFunction<GraphqlTypes.UploadFundDocsMutation, GraphqlTypes.UploadFundDocsMutationVariables>;

/**
 * __useUploadFundDocsMutation__
 *
 * To run a mutation, you first call `useUploadFundDocsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFundDocsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFundDocsMutation, { data, loading, error }] = useUploadFundDocsMutation({
 *   variables: {
 *      fundAdminServiceId: // value for 'fundAdminServiceId'
 *      s3ObjectKeys: // value for 's3ObjectKeys'
 *      documentsType: // value for 'documentsType'
 *   },
 * });
 */
export function useUploadFundDocsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UploadFundDocsMutation, GraphqlTypes.UploadFundDocsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UploadFundDocsMutation, GraphqlTypes.UploadFundDocsMutationVariables>(UploadFundDocsDocument, options);
      }
export type UploadFundDocsMutationHookResult = ReturnType<typeof useUploadFundDocsMutation>;
export type UploadFundDocsMutationResult = Apollo.MutationResult<GraphqlTypes.UploadFundDocsMutation>;
export type UploadFundDocsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UploadFundDocsMutation, GraphqlTypes.UploadFundDocsMutationVariables>;
export const GetGroupsDocument = gql`
    query GetGroups($userIds: [ID!]) {
  groups(userIds: $userIds) {
    edges {
      node {
        id
        title
        memberCount
        roles {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetGroupsQuery__
 *
 * To run a query within a React component, call `useGetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetGroupsQuery, GraphqlTypes.GetGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGroupsQuery, GraphqlTypes.GetGroupsQueryVariables>(GetGroupsDocument, options);
      }
export function useGetGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGroupsQuery, GraphqlTypes.GetGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGroupsQuery, GraphqlTypes.GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
// @ts-ignore
export function useGetGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGroupsQuery, GraphqlTypes.GetGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGroupsQuery, GraphqlTypes.GetGroupsQueryVariables>;
export function useGetGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGroupsQuery, GraphqlTypes.GetGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGroupsQuery | undefined, GraphqlTypes.GetGroupsQueryVariables>;
export function useGetGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGroupsQuery, GraphqlTypes.GetGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGroupsQuery, GraphqlTypes.GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
export type GetGroupsQueryHookResult = ReturnType<typeof useGetGroupsQuery>;
export type GetGroupsLazyQueryHookResult = ReturnType<typeof useGetGroupsLazyQuery>;
export type GetGroupsSuspenseQueryHookResult = ReturnType<typeof useGetGroupsSuspenseQuery>;
export type GetGroupsQueryResult = Apollo.QueryResult<GraphqlTypes.GetGroupsQuery, GraphqlTypes.GetGroupsQueryVariables>;
export const CanopyGroupUsersDocument = gql`
    query CanopyGroupUsers($input: CanopyGroupUsersInput!) {
  canopyGroupUsers(input: $input) {
    ... on CanopyGroupUsersOutput {
      users {
        userId
        fullName
        emailAddress
        activeWorkspaceCount
        lastAccessTimestamp
      }
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;

/**
 * __useCanopyGroupUsersQuery__
 *
 * To run a query within a React component, call `useCanopyGroupUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanopyGroupUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanopyGroupUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCanopyGroupUsersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.CanopyGroupUsersQuery, GraphqlTypes.CanopyGroupUsersQueryVariables> & ({ variables: GraphqlTypes.CanopyGroupUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.CanopyGroupUsersQuery, GraphqlTypes.CanopyGroupUsersQueryVariables>(CanopyGroupUsersDocument, options);
      }
export function useCanopyGroupUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.CanopyGroupUsersQuery, GraphqlTypes.CanopyGroupUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.CanopyGroupUsersQuery, GraphqlTypes.CanopyGroupUsersQueryVariables>(CanopyGroupUsersDocument, options);
        }
// @ts-ignore
export function useCanopyGroupUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.CanopyGroupUsersQuery, GraphqlTypes.CanopyGroupUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CanopyGroupUsersQuery, GraphqlTypes.CanopyGroupUsersQueryVariables>;
export function useCanopyGroupUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CanopyGroupUsersQuery, GraphqlTypes.CanopyGroupUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CanopyGroupUsersQuery | undefined, GraphqlTypes.CanopyGroupUsersQueryVariables>;
export function useCanopyGroupUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CanopyGroupUsersQuery, GraphqlTypes.CanopyGroupUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.CanopyGroupUsersQuery, GraphqlTypes.CanopyGroupUsersQueryVariables>(CanopyGroupUsersDocument, options);
        }
export type CanopyGroupUsersQueryHookResult = ReturnType<typeof useCanopyGroupUsersQuery>;
export type CanopyGroupUsersLazyQueryHookResult = ReturnType<typeof useCanopyGroupUsersLazyQuery>;
export type CanopyGroupUsersSuspenseQueryHookResult = ReturnType<typeof useCanopyGroupUsersSuspenseQuery>;
export type CanopyGroupUsersQueryResult = Apollo.QueryResult<GraphqlTypes.CanopyGroupUsersQuery, GraphqlTypes.CanopyGroupUsersQueryVariables>;
export const EditUserDocument = gql`
    mutation EditUser($objectId: ID!, $objectInput: EditUserInput!, $arenaId: ID) {
  userOps {
    editUser(objectId: $objectId, objectInput: $objectInput, arenaId: $arenaId) {
      user {
        id
        emailAddress
      }
    }
  }
}
    `;
export type EditUserMutationFn = Apollo.MutationFunction<GraphqlTypes.EditUserMutation, GraphqlTypes.EditUserMutationVariables>;

/**
 * __useEditUserMutation__
 *
 * To run a mutation, you first call `useEditUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserMutation, { data, loading, error }] = useEditUserMutation({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      objectInput: // value for 'objectInput'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useEditUserMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EditUserMutation, GraphqlTypes.EditUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EditUserMutation, GraphqlTypes.EditUserMutationVariables>(EditUserDocument, options);
      }
export type EditUserMutationHookResult = ReturnType<typeof useEditUserMutation>;
export type EditUserMutationResult = Apollo.MutationResult<GraphqlTypes.EditUserMutation>;
export type EditUserMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EditUserMutation, GraphqlTypes.EditUserMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($emailAddress: String!, $firstName: String!, $lastName: String!, $groups: [String!], $arenaId: ID) {
  userOps {
    createUser(
      emailAddress: $emailAddress
      firstName: $firstName
      lastName: $lastName
      groups: $groups
      arenaId: $arenaId
    ) {
      user {
        id
        fullName
        emailAddress
      }
    }
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateUserMutation, GraphqlTypes.CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      groups: // value for 'groups'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateUserMutation, GraphqlTypes.CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateUserMutation, GraphqlTypes.CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<GraphqlTypes.CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateUserMutation, GraphqlTypes.CreateUserMutationVariables>;
export const GetCcToolsUserDocument = gql`
    query GetCcToolsUser($userId: ID!) {
  getUserForCcTools(userId: $userId) {
    fullName
    emailAddress
    groups {
      edges {
        node {
          title
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetCcToolsUserQuery__
 *
 * To run a query within a React component, call `useGetCcToolsUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCcToolsUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCcToolsUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCcToolsUserQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCcToolsUserQuery, GraphqlTypes.GetCcToolsUserQueryVariables> & ({ variables: GraphqlTypes.GetCcToolsUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCcToolsUserQuery, GraphqlTypes.GetCcToolsUserQueryVariables>(GetCcToolsUserDocument, options);
      }
export function useGetCcToolsUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCcToolsUserQuery, GraphqlTypes.GetCcToolsUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCcToolsUserQuery, GraphqlTypes.GetCcToolsUserQueryVariables>(GetCcToolsUserDocument, options);
        }
// @ts-ignore
export function useGetCcToolsUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCcToolsUserQuery, GraphqlTypes.GetCcToolsUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCcToolsUserQuery, GraphqlTypes.GetCcToolsUserQueryVariables>;
export function useGetCcToolsUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCcToolsUserQuery, GraphqlTypes.GetCcToolsUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCcToolsUserQuery | undefined, GraphqlTypes.GetCcToolsUserQueryVariables>;
export function useGetCcToolsUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCcToolsUserQuery, GraphqlTypes.GetCcToolsUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCcToolsUserQuery, GraphqlTypes.GetCcToolsUserQueryVariables>(GetCcToolsUserDocument, options);
        }
export type GetCcToolsUserQueryHookResult = ReturnType<typeof useGetCcToolsUserQuery>;
export type GetCcToolsUserLazyQueryHookResult = ReturnType<typeof useGetCcToolsUserLazyQuery>;
export type GetCcToolsUserSuspenseQueryHookResult = ReturnType<typeof useGetCcToolsUserSuspenseQuery>;
export type GetCcToolsUserQueryResult = Apollo.QueryResult<GraphqlTypes.GetCcToolsUserQuery, GraphqlTypes.GetCcToolsUserQueryVariables>;
export const GetCcToolsUsersDocument = gql`
    query GetCCToolsUsers {
  usersCcTools(sort: [FIRST_NAME_ASC, LAST_NAME_ASC, EMAIL_ADDRESS_ASC]) {
    edges {
      node {
        id
        fullName
        emailAddress
        activeWorkspacesCount
        lastAccessTimestamp
        hasBulkArenaAccess
      }
    }
  }
}
    `;

/**
 * __useGetCcToolsUsersQuery__
 *
 * To run a query within a React component, call `useGetCcToolsUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCcToolsUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCcToolsUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCcToolsUsersQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCcToolsUsersQuery, GraphqlTypes.GetCcToolsUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCcToolsUsersQuery, GraphqlTypes.GetCcToolsUsersQueryVariables>(GetCcToolsUsersDocument, options);
      }
export function useGetCcToolsUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCcToolsUsersQuery, GraphqlTypes.GetCcToolsUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCcToolsUsersQuery, GraphqlTypes.GetCcToolsUsersQueryVariables>(GetCcToolsUsersDocument, options);
        }
// @ts-ignore
export function useGetCcToolsUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCcToolsUsersQuery, GraphqlTypes.GetCcToolsUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCcToolsUsersQuery, GraphqlTypes.GetCcToolsUsersQueryVariables>;
export function useGetCcToolsUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCcToolsUsersQuery, GraphqlTypes.GetCcToolsUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCcToolsUsersQuery | undefined, GraphqlTypes.GetCcToolsUsersQueryVariables>;
export function useGetCcToolsUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCcToolsUsersQuery, GraphqlTypes.GetCcToolsUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCcToolsUsersQuery, GraphqlTypes.GetCcToolsUsersQueryVariables>(GetCcToolsUsersDocument, options);
        }
export type GetCcToolsUsersQueryHookResult = ReturnType<typeof useGetCcToolsUsersQuery>;
export type GetCcToolsUsersLazyQueryHookResult = ReturnType<typeof useGetCcToolsUsersLazyQuery>;
export type GetCcToolsUsersSuspenseQueryHookResult = ReturnType<typeof useGetCcToolsUsersSuspenseQuery>;
export type GetCcToolsUsersQueryResult = Apollo.QueryResult<GraphqlTypes.GetCcToolsUsersQuery, GraphqlTypes.GetCcToolsUsersQueryVariables>;
export const GetWorkspacesDocument = gql`
    query GetWorkspaces($sortByName: Boolean, $searchTerm: String, $first: Int, $last: Int, $before: String, $after: String) {
  arenas(
    sortByName: $sortByName
    searchTerm: $searchTerm
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        id
        name
        aboutText
        assignedUsersCount
        lastAccessTimestamp
        jsqHostname
      }
    }
    count
  }
}
    `;

/**
 * __useGetWorkspacesQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesQuery({
 *   variables: {
 *      sortByName: // value for 'sortByName'
 *      searchTerm: // value for 'searchTerm'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetWorkspacesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetWorkspacesQuery, GraphqlTypes.GetWorkspacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetWorkspacesQuery, GraphqlTypes.GetWorkspacesQueryVariables>(GetWorkspacesDocument, options);
      }
export function useGetWorkspacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetWorkspacesQuery, GraphqlTypes.GetWorkspacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetWorkspacesQuery, GraphqlTypes.GetWorkspacesQueryVariables>(GetWorkspacesDocument, options);
        }
// @ts-ignore
export function useGetWorkspacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWorkspacesQuery, GraphqlTypes.GetWorkspacesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetWorkspacesQuery, GraphqlTypes.GetWorkspacesQueryVariables>;
export function useGetWorkspacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWorkspacesQuery, GraphqlTypes.GetWorkspacesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetWorkspacesQuery | undefined, GraphqlTypes.GetWorkspacesQueryVariables>;
export function useGetWorkspacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWorkspacesQuery, GraphqlTypes.GetWorkspacesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetWorkspacesQuery, GraphqlTypes.GetWorkspacesQueryVariables>(GetWorkspacesDocument, options);
        }
export type GetWorkspacesQueryHookResult = ReturnType<typeof useGetWorkspacesQuery>;
export type GetWorkspacesLazyQueryHookResult = ReturnType<typeof useGetWorkspacesLazyQuery>;
export type GetWorkspacesSuspenseQueryHookResult = ReturnType<typeof useGetWorkspacesSuspenseQuery>;
export type GetWorkspacesQueryResult = Apollo.QueryResult<GraphqlTypes.GetWorkspacesQuery, GraphqlTypes.GetWorkspacesQueryVariables>;